import bradMontgomeryImage from './images/brad-montgomery.jpg';

const categoryImages = {
  axeThrowing:
    'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=1200&q=80',

  escapeRoom:
    'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=1200&q=80',

  creative:
    'https://images.unsplash.com/photo-1452860606245-08befc0ff44b?auto=format&fit=crop&w=1200&q=80',

  pottery:
    'https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?auto=format&fit=crop&w=1200&q=80',

  scavengerHunt:
    'https://images.unsplash.com/photo-1559027615-cd4628902d4a?auto=format&fit=crop&w=1200&q=80',

  iceSkating:
    'https://images.unsplash.com/photo-1515703407324-5f753afd8be8?auto=format&fit=crop&w=1200&q=80',

  foodAndDrinks:
    'https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&w=1200&q=80',

  brewery:
    'https://images.unsplash.com/photo-1532634982-b19179a15f50?auto=format&fit=crop&w=1200&q=80',

  museum:
    'https://images.unsplash.com/photo-1545987796-200677ee1011?auto=format&fit=crop&w=1200&q=80',

  outdoorEvent:
    'https://images.unsplash.com/photo-1527529482837-4698179dc6ce?auto=format&fit=crop&w=1200&q=80',

  golf:
    'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?auto=format&fit=crop&w=1200&q=80',

  bowling:
    'https://images.unsplash.com/photo-1573500278253-2acfb5211b7c?auto=format&fit=crop&w=1200&q=80',

  activeGames:
    'https://images.unsplash.com/photo-1517649763962-0c623066013b?auto=format&fit=crop&w=1200&q=80',

  climbing:
    'https://images.unsplash.com/photo-1522163182402-834f871fd851?auto=format&fit=crop&w=1200&q=80',

  skiing:
    'https://images.unsplash.com/photo-1551524559-8af4e6624178?auto=format&fit=crop&w=1200&q=80',

  miniGolf:
    'https://images.unsplash.com/photo-1578301978693-85fa9c0320b9?auto=format&fit=crop&w=1200&q=80',

  foodTour:
    'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1200&q=80',
  
};



export const experiences = [
  {
    id: 'denver-this-is-a-clue-self-hosted',
    name: 'This Is A Clue — Self-Hosted Trivia',
    active: true,
    preferred: true,
    partnerPageUrl: 'https://thisisaclue.teamward.ai/',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$',
    groupSize: '15–400',
    duration: '1–2 hrs',
    setting: 'Virtual / At your office',
    vibe: ['Social', 'Team Building', 'Friendly Competition'],
    image: categoryImages.activeGames,
    summary: 'A ready-to-run trivia deck with questions, a picture round, and a scoring key. A colleague hosts the game; ideal for office and remote teams.',
    bestFor: 'Team celebrations, employee appreciation, holiday parties, conferences, and retreats.',
    details: 'A ready-to-run trivia deck with questions, a picture round, and a scoring key. A colleague hosts the game; ideal for office and remote teams. Base package pricing is flat for the group. Larger groups may need an additional host, quoted separately. Venue and food are separate.',
    planningNotes: 'Choose one trivia format. Plan 2–3 weeks ahead for custom rounds. Additional hosts and travel fees are confirmed before booking.',
    contact: 'mailto:mkuhl@teamward.ai',
  },
  {
    id: 'denver-this-is-a-clue-hosted',
    name: 'This Is A Clue — Hosted Trivia Night',
    active: true,
    preferred: true,
    partnerPageUrl: 'https://thisisaclue.teamward.ai/',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$',
    groupSize: '15–400',
    duration: '1–2 hrs',
    setting: 'At your office / Your venue',
    vibe: ['Social', 'Team Building', 'Friendly Competition'],
    image: categoryImages.activeGames,
    summary: 'A trained host runs trivia at your office or chosen venue, including sound gear, scorecards, and live scoring.',
    bestFor: 'Team celebrations, employee appreciation, holiday parties, conferences, and retreats.',
    details: 'A trained host runs trivia at your office or chosen venue, including sound gear, scorecards, and live scoring. Base package pricing is flat for the group. Larger groups may need an additional host, quoted separately. Venue and food are separate.',
    planningNotes: 'Choose one trivia format. Plan 2–3 weeks ahead for custom rounds. Additional hosts and travel fees are confirmed before booking.',
    contact: 'mailto:mkuhl@teamward.ai',
  },
  {
    id: 'denver-this-is-a-clue-custom',
    name: 'This Is A Clue — Fully Custom Trivia',
    active: true,
    preferred: true,
    partnerPageUrl: 'https://thisisaclue.teamward.ai/',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$',
    groupSize: '15–400',
    duration: '1–2 hrs',
    setting: 'At your office / Your venue',
    vibe: ['Social', 'Team Building', 'Friendly Competition'],
    image: categoryImages.activeGames,
    summary: 'Trivia written for your organization. Starts at $300; extensive customization and several feedback rounds can cost up to $500. Confirm hosting arrangements and final scope before booking.',
    bestFor: 'Team celebrations, employee appreciation, holiday parties, conferences, and retreats.',
    details: 'Trivia written for your organization. Starts at $300; extensive customization and several feedback rounds can cost up to $500. Confirm hosting arrangements and final scope before booking. Base package pricing is flat for the group. Larger groups may need an additional host, quoted separately. Venue and food are separate.',
    planningNotes: 'Choose one trivia format. Plan 2–3 weeks ahead for custom rounds. Additional hosts and travel fees are confirmed before booking.',
    contact: 'mailto:mkuhl@teamward.ai',
  },
  {
    id: 'casper-oil-city-axe-company',
    name: 'Oil City Axe Company',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Team Building',
    price: '$$',
    groupSize: '6–35',
    duration: '1–2 hrs',
    setting: 'Indoor',
    vibe: ['Competitive', 'Memorable', 'High energy'],
    image: 'https://images.unsplash.com/photo-1761873763418-2c9596bc8c65?q=80&w=2187&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'Axe throwing, friendly competition, and a bold indoor setting for teams that want something more memorable than dinner.',
    bestFor:
      'Small to mid-size teams, sales groups, celebrations, and teams that like structured competition.',
    details:
      'Oil City Axe Company offers axe throwing in Casper with options that work well for private groups and team tournaments. A simple bracket, prizes, and food afterward would make this an easy office outing.',
    contact: 'https://www.oilcityaxecompany.com/axe-throwing.html',
  },
  {
    id: 'casper-escape-307',
    name: 'Escape307',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Escape Room',
    price: '$$',
    groupSize: '4–20',
    duration: '60–90 min',
    setting: 'Indoor',
    vibe: ['Problem-solving', 'Competitive', 'Collaborative'],
    image: 'https://images.unsplash.com/photo-1463871181391-8550cd89c179?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A puzzle-based team experience where coworkers solve clues, race the clock, and compare results afterward.',
    bestFor:
      'Teams that enjoy problem-solving, communication challenges, and low-physical-activity outings.',
    details:
      'Escape307 is a strong indoor option for Casper teams. Split larger teams into groups, run simultaneous or staggered games, then meet up afterward for food or awards.',
    contact: 'https://escape307.com/',
  },
  {
    id: 'casper-pottery-by-you',
    name: 'Pottery by You',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Creative',
    price: '$$',
    groupSize: '6–30',
    duration: '90–120 min',
    setting: 'Indoor',
    vibe: ['Creative', 'Relaxed', 'Conversation-friendly'],
    image: 'https://images.unsplash.com/photo-1657395348373-28a0cb49804b?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A relaxed creative outing where teams can paint pottery, make art, and talk while doing something hands-on.',
    bestFor:
      'Admin teams, healthcare offices, school staff, women-led teams, and groups that prefer calm activities over competition.',
    details:
      'Pottery by You offers paint-your-own pottery, classes, and creative projects in Casper. It is a good option for teams that want a slower-paced activity with built-in conversation.',
    contact: 'https://www.potterybyyou.biz/',
  },
  {
    id: 'casper-adventure-games',
    name: 'AdVenture Games Casper',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Scavenger Hunt',
    price: '$$',
    groupSize: '10–100',
    duration: '1.5–3 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Competitive', 'Problem-solving', 'Customizable'],
    image: 'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'App-based and facilitated team-building games that can get coworkers moving, solving clues, and working together.',
    bestFor:
      'Corporate teams, leadership groups, training days, and companies that want a more structured team-building program.',
    details:
      'AdVenture Games offers Casper team-building experiences including scavenger-style challenges, code cracking, puzzles, and custom activities. This is a strong option for a more intentional team-development outing.',
    contact:
      'https://www.adventuregamesinc.com/locations/wyoming-team-building/casper-team-building/',
  },
  {
    id: 'casper-ice-arena-private-rental',
    name: 'Casper Ice Arena Private Rental',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Active',
    price: '$$',
    groupSize: '15–100',
    duration: '1–2 hrs',
    setting: 'Indoor',
    vibe: ['Active', 'Unique', 'Seasonal'],
    image: categoryImages.iceSkating,
    summary:
      'A private ice-skating rental that gives teams a unique indoor outing with lots of built-in fun.',
    bestFor:
      'Winter events, family-friendly company parties, active teams, and groups looking for something different.',
    details:
      'Casper Ice Arena offers private group rentals, making it a practical option for corporate events, team-building activities, and group celebrations.',
    contact: 'https://www.casperwy.gov/business_detail_T11_R202.php',
  },
  {
    id: 'casper-backwards-distilling',
    name: 'Backwards Distilling Company',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '6–40',
    duration: '1.5–2 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Relaxed', 'Adults only'],
    image: 'https://images.unsplash.com/photo-1529264978834-666a0e99f884?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A local Casper tasting-room experience for adult teams that want a social, low-pressure outing.',
    bestFor:
      'Small office socials, leadership dinners, client events, and adult teams looking for a relaxed evening activity.',
    details:
      'Backwards Distilling has a downtown Casper tasting room and events calendar. This would work well as a happy-hour style office outing or a stop before dinner.',
    contact: 'https://www.backwardsdistilling.com/',
  },
  {
    id: 'casper-nicolaysen-art-museum',
    name: 'The Nicolaysen Art Museum',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Creative',
    price: '$$',
    groupSize: '8–50',
    duration: '1.5–3 hrs',
    setting: 'Indoor',
    vibe: ['Creative', 'Cultural', 'Conversation-friendly'],
    image: 'https://images.unsplash.com/photo-1577084381380-3b9ea4153664?q=80&w=2206&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A creative and cultural outing built around art, conversation, workshops, or a private event space.',
    bestFor:
      'Professional teams, nonprofit teams, education groups, and companies that want a polished indoor experience.',
    details:
      'The Nicolaysen Art Museum offers contemporary art, educational programming, workshops, and private event options. It is a good fit for teams that want something more thoughtful than a standard activity.',
    contact: 'https://www.thenic.org/',
  },
  {
    id: 'casper-david-street-station',
    name: 'David Street Station',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$$',
    groupSize: '25–200',
    duration: '2–4 hrs',
    setting: 'Outdoor',
    vibe: ['Social', 'Seasonal', 'Large group'],
    image: 'https://images.unsplash.com/photo-1716582873749-f4fb77fe9957?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A downtown outdoor venue option for larger team gatherings, casual socials, and seasonal company events.',
    bestFor:
      'Large teams, summer socials, family-friendly company gatherings, and casual outdoor events.',
    details:
      'David Street Station is a downtown Casper gathering space available for qualifying rentals and events. It could work well for a company picnic, outdoor social, or seasonal event.',
    contact:
      'https://www.davidstreetstation.com/vendor-forms/rent-david-street-station',
  },
  {
    id: 'casper-el-marko-lanes',
    name: 'El Marko Lanes',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$',
    groupSize: '8–60',
    duration: '1.5–2.5 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Competitive', 'Easy planning'],
    image: 'https://plus.unsplash.com/premium_photo-1679321795552-b1f69a68b80e?q=80&w=2232&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A classic bowling outing with food, drinks, and simple competition for teams that want an easy indoor activity.',
    bestFor:
      'Casual office socials, mixed-age teams, company celebrations, and groups that want low-pressure fun.',
    details:
      'El Marko Lanes is a Casper bowling option with restaurant and bar amenities. It works well for a simple office outing because teams can bowl, eat, socialize, and compete without a complicated schedule.',
    contact: 'https://www.visitcasper.com/directory/el-marko-lanes/',
  },
  {
    id: 'casper-artisan-alley',
    name: 'Artisan Alley',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Creative',
    price: '$$',
    groupSize: '6–35',
    duration: '1.5–2.5 hrs',
    setting: 'Indoor',
    vibe: ['Creative', 'Relaxed', 'Conversation-friendly'],
    image: 'https://images.unsplash.com/photo-1753098498024-c2a51a8e021c?q=80&w=2080&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A paint-and-create outing for teams that want something relaxed, social, and hands-on.',
    bestFor:
      'Teams that prefer conversation over competition, staff appreciation events, and smaller office groups.',
    details:
      'Artisan Alley offers group classes, office get-togethers, and creative events. This would be a strong fit for a team that wants an approachable art activity without needing prior experience.',
    contact: 'https://artisanalley307.com/',
  },
  {
    id: 'casper-art-321',
    name: 'ART 321',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Creative',
    price: '$$',
    groupSize: '8–50',
    duration: '1.5–3 hrs',
    setting: 'Indoor',
    vibe: ['Creative', 'Cultural', 'Local'],
    image: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?q=80&w=2360&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A downtown arts hub that can work for gallery visits, creative workshops, and locally focused team experiences.',
    bestFor:
      'Nonprofits, education teams, professional groups, and companies that want a thoughtful local outing.',
    details:
      'ART 321 is Casper’s community arts hub, with exhibits, classes, a gift shop, and local creative programming. It is a good option for teams that want a cultural or hands-on experience.',
    contact: 'https://www.art321.org/',
  },
  {
    id: 'casper-municipal-golf-course',
    name: 'Casper Municipal Golf Course',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$$',
    groupSize: '8–80',
    duration: '3–5 hrs',
    setting: 'Outdoor',
    vibe: ['Active', 'Social', 'Large group'],
    image: 'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A golf outing or tournament-style event for teams that want fresh air, friendly competition, and a traditional company outing feel.',
    bestFor:
      'Leadership teams, client events, sales teams, summer outings, and companies that want a classic outdoor format.',
    details:
      'Casper Municipal Golf Course specifically notes that it can host golf tournaments and company outings. This works best when planned as a scramble, casual tournament, or client-appreciation event.',
    contact: 'https://www.casperwy.gov/explore/casper_municipal_golf_course/events.php',
  },
  {
    id: 'casper-hogadon-basin',
    name: 'Hogadon Basin Ski Area',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$$$',
    groupSize: '8–80',
    duration: 'Half day',
    setting: 'Outdoor',
    vibe: ['Active', 'Seasonal', 'Memorable'],
    image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A seasonal mountain outing for teams that want skiing, snowboarding, lodge time, or a memorable winter event.',
    bestFor:
      'Winter team outings, adventurous groups, employee appreciation days, and companies that want something uniquely Casper.',
    details:
      'Hogadon Basin offers lift tickets, rentals, lessons, food and beverage options, and event rental information. It could work as a winter activity day or a private seasonal gathering.',
    contact: 'https://www.casperwy.gov/explore/hogadon_basin_ski_area/index.php',
  },
  {
    id: 'casper-fort-caspar-museum',
    name: 'Fort Caspar Museum',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '8–60',
    duration: '1–2 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Cultural', 'Relaxed', 'Local history'],
    image: 'https://images.unsplash.com/photo-1599766431396-2405fdfcf5e4?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A local-history outing with museum exhibits, group visit options, and nearby rentable spaces.',
    bestFor:
      'Education teams, nonprofit teams, leadership retreats, and groups that want a quieter cultural experience.',
    details:
      'Fort Caspar Museum supports group visits and has indoor meeting rooms and outside locations available for rentals. It could pair well with lunch, a short workshop, or a Casper history-themed outing.',
    contact: 'https://www.casperwy.gov/explore/fort_caspar_museum/groups.php',
  },
  {
    id: 'casper-park-facility-rentals',
    name: 'City of Casper Park & Facility Rentals',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$',
    groupSize: '15–150',
    duration: '2–4 hrs',
    setting: 'Outdoor',
    vibe: ['Social', 'Relaxed', 'Family-friendly', 'Large group'],
    image: 'https://images.unsplash.com/photo-1517457452519-3071133d3f0e?q=80&w=2338&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A flexible outdoor option for company picnics, lawn games, BBQs, and casual team gatherings.',
    bestFor:
      'Large teams, family-friendly company parties, summer socials, and budget-conscious office events.',
    details:
      'The City of Casper offers reservable parks and facilities for special events, parties, and barbecues. This is a practical option for companies that want a casual outing without booking a traditional venue.',
    contact: 'https://www.casperwy.gov/explore/parks_and_trails/park_facility_rentals.php',
  },
  {
    id: 'casper-peak-indoor-climbing',
    name: 'The Peak Indoor Rock Climbing',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Active',
    price: '$$',
    groupSize: '6–30',
    duration: '1.5–2 hrs',
    setting: 'Indoor',
    vibe: ['Active', 'Confidence-building', 'Memorable'],
    image: 'https://images.unsplash.com/photo-1520156557489-31c63271fcd4?q=80&w=2187&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'An indoor climbing option for teams that want an active outing without needing perfect weather.',
    bestFor:
      'Small teams, adventurous groups, fitness-minded employees, and teams that want to try something new together.',
    details:
      'The Peak Indoor Rock Climbing is listed as an indoor climbing option in Casper. This could be a memorable team experience for smaller groups, especially when paired with food afterward.',
    contact: 'https://www.sportsengine.com/org/the-peak-indoor-rock-climbing',
  },
  {
    id: 'denver-escapology',
    name: 'Escapology Denver',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Escape Room',
    price: '$$',
    groupSize: '6–50',
    duration: '60–90 min',
    setting: 'Indoor',
    vibe: ['Problem-solving', 'Competitive', 'Teamwork'],
    image: 'https://images.unsplash.com/photo-1631164159408-540fe1e32537?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A polished escape-room option for teams that want puzzles, urgency, and built-in collaboration.',
    bestFor:
      'Corporate teams, departments, leadership groups, and mixed teams that need an easy indoor activity.',
    details:
      'Escapology Denver offers team-building escape room packages focused on teamwork, participation, and morale. It is a strong Denver option for a structured indoor team outing.',
    contact: 'https://www.escapology.com/en/denver-co/packages/team-building',
  },
  {
    id: 'denver-bad-axe-throwing',
    name: 'Bad Axe Throwing Denver',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Team Building',
    price: '$$',
    groupSize: '6–80',
    duration: '1–2 hrs',
    setting: 'Indoor',
    vibe: ['Competitive', 'Active', 'Memorable'],
    image: 'https://images.unsplash.com/photo-1614036056923-b707c5258c01?q=80&w=2344&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A high-energy axe throwing outing with coaching, competition, and an easy group format.',
    bestFor:
      'Sales teams, startup teams, celebrations, client events, and teams that want something bold.',
    details:
      'Bad Axe Throwing Denver offers private lanes, coaching, and group-friendly axe throwing. It is a strong option for a casual corporate event with a tournament format.',
    contact: 'https://badaxethrowing.com/locations/axe-throwing-denver/',
  },
  {
    id: 'denver-topgolf-centennial',
    name: 'Topgolf Centennial',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '8–200',
    duration: '2–3 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Social', 'Active', 'Large group'],
    image: 'https://images.unsplash.com/photo-1604702686571-f03d002a7c53?q=80&w=627&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A reliable large-group outing with golf bays, food, drinks, and event packages.',
    bestFor:
      'Company parties, client events, holiday parties, and teams with mixed activity levels.',
    details:
      'Topgolf Centennial offers covered hitting bays, catering packages, and event options for company events and social gatherings. It is one of the easiest Denver-area options for larger teams.',
    contact: 'https://topgolf.com/us/centennial/',
  },
  {
    id: 'denver-upstairs-circus',
    name: 'Upstairs Circus Denver',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Creative',
    price: '$$',
    groupSize: '8–100',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Creative', 'Unique'],
      image: 'https://images.unsplash.com/photo-1540331547168-8b63109225b7?q=80&w=2165&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A DIY workshop and bar where teams can make a project, socialize, and leave with something they created.',
    bestFor:
      'Creative teams, admin teams, mixed departments, and groups that want a social activity without intense competition.',
    details:
      'Upstairs Circus offers group parties, private buyouts, DIY projects, and a bar-style social format. It is a good fit for a polished but relaxed team outing.',
    contact: 'https://upstairscircus.com/group-parties-events/',
  },
  {
    id: 'denver-hd-escape-rooms',
    name: 'HD Escape Rooms',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Escape Room',
    price: '$$',
    groupSize: '6–40',
    duration: '60–90 min',
    setting: 'Indoor',
    vibe: ['Competitive', 'Collaborative', 'Repeatable'],
    image: 'https://images.unsplash.com/photo-1730804518415-75297e8d2a41?q=80&w=2062&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A Denver-area escape room option for teams that want different difficulty levels and replayable challenge formats.',
    bestFor:
      'Problem-solving teams, engineering groups, managers, and companies that want an indoor team challenge.',
    details:
      'HD Escape Rooms offers corporate escape room experiences for Denver-area businesses, with multiple room options and varying difficulty levels.',
    contact: 'https://www.hdescaperooms.com/escape-room-corporate-team-building/',
  },
  {
    id: 'denver-archery-games',
    name: 'Archery Games Denver',
    active: false,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Active',
    price: '$$',
    groupSize: '6–80',
    duration: '75 min',
    setting: 'Indoor',
    vibe: ['Active', 'Competitive', 'High energy'],
    image: 'https://images.unsplash.com/photo-1538432091670-e6b79bd9bffa?q=80&w=2232&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'Archery dodgeball for teams that want an active, funny, and highly memorable outing.',
    bestFor:
      'Younger teams, high-energy groups, startups, sales teams, and companies that want a physical activity.',
    details:
      'Archery Games Denver hosts corporate team-building events for groups of 6 to 80. Staff handle the training and game facilitation, making it easier for planners.',
    contact:
      'https://archerygamesdenver.com/denver-corporate-team-building-events/',
  },
  {
    id: 'denver-puttshack',
    name: 'Puttshack Denver',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$$',
    groupSize: '13–200',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Competitive', 'Food & drinks'],
    image: 'https://images.unsplash.com/photo-1556558722-92a89f403193?q=80&w=2187&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'Tech-infused mini golf with food and drinks for teams that want a social outing with light competition.',
    bestFor:
      'Company celebrations, happy hours, holiday parties, and teams that want a polished entertainment venue.',
    details:
      'Puttshack Denver offers corporate event space, mini golf, food, drinks, and event support. It is a strong option for teams that want an energetic indoor outing.',
    contact: 'https://www.puttshack.com/parties/denver/',
  },
  {
    id: 'denver-delicious-food-tours',
    name: 'Delicious Denver Food Tours',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '8–40',
    duration: '2–3 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Social', 'Local', 'Low pressure'],
    image: categoryImages.foodTour,
    summary:
      'A guided food tour option for teams that want conversation, local flavor, and a no-planning-required experience.',
    bestFor:
      'Client events, leadership groups, visiting teams, and companies hosting out-of-town employees.',
    details:
      'Delicious Denver Food Tours offers private food and drink tours for groups and team-building events. This works well when the goal is connection rather than competition.',
    contact: 'https://www.deliciousdenverfoodtours.com/',
  },
  {
    id: 'denver-punch-bowl-social',
    name: 'Punch Bowl Social Denver',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$$',
    groupSize: '10–200',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Food & drinks', 'Flexible'],
    image: 'https://plus.unsplash.com/premium_photo-1679913793265-e16a3a9b603e?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A large entertainment venue with food, drinks, bowling, karaoke, ping pong, arcade games, and other social activities.',
    bestFor:
      'Company parties, happy hours, holiday events, and teams that want multiple activity options in one place.',
    details:
      'Punch Bowl Social Denver works well for mixed groups because coworkers can choose from several activities instead of being locked into one format. It is especially useful for larger teams.',
    contact: 'https://punchbowlsocial.com/location/denver',
  },
  {
    id: 'denver-lucky-strike',
    name: 'Lucky Strike Denver',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$$',
    groupSize: '10–150',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Competitive', 'Food & drinks'],
    image: 'https://images.unsplash.com/photo-1645534730335-75ff8b548527?q=80&w=2187&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A bowling-centered corporate event option with food, drinks, entertainment, and easy group planning.',
    bestFor:
      'Office celebrations, team-building events, client nights, and departments that want a polished indoor outing.',
    details:
      'Lucky Strike Denver offers corporate event packages that blend bowling, food, drinks, and entertainment. It is a strong choice for a classic team outing with more upscale event support.',
    contact: 'https://www.luckystrikeent.com/location/lucky-strike-denver/parties/corporate-parties',
  },
  {
    id: 'denver-escape-the-room',
    name: 'Escape The Room Denver',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Escape Room',
    price: '$$',
    groupSize: '10–100',
    duration: '60–90 min',
    setting: 'Indoor',
    vibe: ['Problem-solving', 'Competitive', 'Teamwork'],
    image: 'https://images.unsplash.com/photo-1554863885-e3a33dd1bc82?q=80&w=2067&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A competition-style escape-room outing that can split departments into teams and compare finish times.',
    bestFor:
      'Departments, startup teams, leadership groups, and companies that want a structured team challenge.',
    details:
      'Escape The Room Denver notes that it has hosted corporate events for Denver-area companies, from small startup teams to departments of 100+. This works well for direct team competition.',
    contact: 'https://escapetheroom.com/denver/team-building/',
  },
  {
    id: 'denver-puzzle-effect',
    name: 'Puzzle Effect Denver',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Escape Room',
    price: '$$',
    groupSize: '4–30',
    duration: '60–90 min',
    setting: 'Indoor',
    vibe: ['Problem-solving', 'Competitive', 'Immersive'],
    image: 'https://images.unsplash.com/photo-1607710533910-d7cdffd9e593?q=80&w=2264&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A story-driven escape-room option for smaller teams that want puzzles, collaboration, and a shared challenge.',
    bestFor:
      'Small teams, managers, engineering groups, and coworkers who enjoy solving clues together.',
    details:
      'Puzzle Effect Denver offers themed escape-room experiences and party options. It is a good fit for smaller office groups that want something focused and interactive.',
    contact: 'https://puzzleeffect.com/denver/',
  },
  {
    id: 'denver-beat-the-bomb',
    name: 'Beat The Bomb Denver',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Active',
    price: '$$$',
    groupSize: '6–100',
    duration: '1.5–2 hrs',
    setting: 'Indoor',
    vibe: ['High energy', 'Competitive', 'Memorable'],
    image: 'https://images.unsplash.com/photo-1527075240784-552cddfbb143?q=80&w=2352&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A high-energy team game where groups move through game rooms and try to avoid getting blasted by paint, foam, or slime.',
    bestFor:
      'Younger teams, startups, sales teams, celebrations, and groups that want a loud, funny, memorable outing.',
    details:
      'Beat The Bomb Denver is built like a real-life team video game, with multiple challenge rooms and a big finale. It is one of the more distinctive high-energy options in Denver.',
    contact: 'https://www.beatthebomb.com/locations/denver',
  },
  {
    id: 'denver-meow-wolf',
    name: 'Meow Wolf Denver',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Creative',
    price: '$$$',
    groupSize: '15–150',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Immersive', 'Creative', 'Memorable'],
    image: 'https://images.unsplash.com/photo-1546640646-89b557854b23?q=80&w=2338&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'An immersive art experience for teams that want something unusual, visually memorable, and easy to talk about afterward.',
    bestFor:
      'Creative teams, company celebrations, visiting teams, and groups that want a distinctive Denver experience.',
    details:
      'Meow Wolf Denver offers group activity options for groups of 15+ and private event possibilities. It works well for teams that want exploration instead of a structured competition.',
    contact: 'https://meowwolf.com/visit/denver/tickets',
  },
  {
    id: 'denver-art-museum-group-tour',
    name: 'Denver Art Museum Group Tour',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$$',
    groupSize: '10–60',
    duration: '1.5–2.5 hrs',
    setting: 'Indoor',
    vibe: ['Relaxed', 'Conversation-friendly', 'Polished'],
    image: 'https://images.unsplash.com/photo-1569783721854-33a99b4c0bae?q=80&w=1428&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A polished cultural outing with group tour options, self-led visits, and easy pairing with lunch or drinks downtown.',
    bestFor:
      'Professional teams, client groups, nonprofit teams, education groups, and teams that want a quieter outing.',
    details:
      'Denver Art Museum offers group tours and self-led group visits by reservation. This is a strong choice for teams that want art, conversation, and a more refined experience.',
    contact: 'https://www.denverartmuseum.org/en/group-tours',
  },
  {
    id: 'denver-microbrew-tour',
    name: 'Denver Microbrew Tour',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '8–60',
    duration: '2–3 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Social', 'Local', 'Adults only'],
    image: 'https://images.unsplash.com/photo-1532634922-8fe0b757fb13?q=80&w=2344&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A guided brewery tour that can turn a standard happy hour into a more organized and memorable team experience.',
    bestFor:
      'Adult teams, client events, visiting employees, and companies that want a social outing with a local Denver angle.',
    details:
      'Denver Microbrew Tour offers private group outings and team-building add-ons. It works well when the goal is social connection, local flavor, and minimal planning.',
    contact: 'https://www.denvermicrobrewtour.com/',
  },
   {
    id: 'casper-gruner-brothers-brewing',
    name: 'Gruner Brothers Brewing',
     active: true,
    city: 'Casper',
    state: 'WY',
     primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '8–60',
    duration: '1.5–2.5 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Social', 'Local', 'Relaxed'],
    image: 'https://images.unsplash.com/photo-1567696911980-2eed69a46042?q=80&w=2187&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A Casper brewery and taproom outing with local beer, mountain views, and an easy social format.',
    bestFor:
      'After-work teams, client socials, leadership groups, and adult teams that want something relaxed and local.',
    details:
      'Gruner Brothers Brewing works well as a low-pressure office outing with drinks, conversation, and a local Casper feel. It could be paired with light food, a short toast, or team awards.',
    contact: 'https://grunerbrewing.com/',
  },
  {
    id: 'casper-gaslight-social',
    name: 'The Gaslight Social',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$',
    groupSize: '10–100',
    duration: '2–3 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Social', 'Food & drinks', 'High energy'],
    image: 'https://images.unsplash.com/photo-1615332579037-3c44b3660b53?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A downtown Casper hangout with food, drinks, arcade-style fun, outdoor space, and live-event energy.',
    bestFor:
      'Company happy hours, casual team celebrations, younger teams, and groups that want flexible social time.',
    details:
      'The Gaslight Social is a strong casual option when the goal is to give coworkers a place to eat, drink, play, and talk without a rigid activity schedule.',
    contact: 'https://thegaslightsocial.com/',
  },
  {
    id: 'casper-three-crowns-golf-club',
    name: 'Three Crowns Golf Club',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$$$',
    groupSize: '8–120',
    duration: '3–5 hrs',
    setting: 'Outdoor',
    vibe: ['Active', 'Social', 'Competitive'],
    image: categoryImages.golf,
    summary:
      'A polished golf outing or corporate event setting with views, event support, and a classic company-outing feel.',
    bestFor:
      'Leadership teams, client events, summer outings, fundraisers, and companies that want a more traditional corporate event.',
    details:
      'Three Crowns Golf Club can work for a scramble, golf tournament, reception, or semi-formal company event. It is a good option when the event should feel more elevated than a casual activity.',
    contact: 'https://www.threecrownsgolfclub.com/',
  },
  {
    id: 'casper-planetarium',
    name: 'Casper Planetarium',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '8–45',
    duration: '1 hr',
    setting: 'Indoor',
    vibe: ['Educational', 'Relaxed', 'Low pressure'],
    image: 'https://images.unsplash.com/photo-1516571748831-5d81767b788d?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A short, unusual indoor outing built around astronomy, full-dome programs, and a different kind of shared experience.',
    bestFor:
      'Education teams, science-minded teams, family-friendly groups, and companies that want a quiet but memorable outing.',
    details:
      'Casper Planetarium is a good add-on outing for teams that want something inexpensive, educational, and easy to schedule. It could pair well with lunch or coffee afterward.',
    contact: 'https://www.natronaschools.org/apps/pages/index.jsp?pREC_ID=2118286&type=d&uREC_ID=2060920',
  },
  {
    id: 'casper-national-historic-trails-center',
    name: 'National Historic Trails Interpretive Center',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '8–80',
    duration: '1–2 hrs',
    setting: 'Indoor',
    vibe: ['Relaxed', 'Educational', 'Conversation-friendly'],
    image: 'https://images.unsplash.com/photo-1657412283840-edafec7b614b?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A Casper cultural outing with interactive exhibits about historic western migration trails.',
    bestFor:
      'Leadership retreats, visiting teams, education groups, nonprofit teams, and companies that want a thoughtful local experience.',
    details:
      'The National Historic Trails Interpretive Center can be used as a quieter team outing, especially for groups that want a local Casper experience that is easy to pair with lunch or a meeting.',
    contact: 'https://www.blm.gov/learn/interpretive-centers/national-historic-trails-interpretive-center',
  },
  {
  id: 'casper-tate-geological-museum',
  name: 'Tate Geological Museum',
    active: true,
  city: 'Casper',
  state: 'WY',
    primaryCategories: ['outings'],
  category: 'Culture',
  price: '$',
  groupSize: '6–50',
  duration: '1–2 hrs',
  setting: 'Indoor',
  vibe: ['Educational', 'Relaxed', 'Low pressure'],
  image: 'https://images.unsplash.com/photo-1557767536-d4ba1fe303fd?q=80&w=2350&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'A free geology and paleontology museum outing featuring fossils, minerals, and Casper College exhibits.',
  bestFor:
    'Education groups, science-minded teams, smaller offices, and teams that want something inexpensive and different.',
  details:
    'Tate Geological Museum is a useful Casper listing because it gives teams a low-cost cultural option that can be paired with coffee, lunch, or a short planning session.',
  contact: 'https://www.caspercollege.edu/tate-geological-museum/',
},
  {
    id: 'casper-wyoming-ale-works',
    name: 'Wyoming Ale Works',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '6–40',
    duration: '1.5–2.5 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Social', 'Food & drinks', 'Easy planning'],
    image: 'https://images.unsplash.com/photo-1586993451228-09818021e309?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A chef-driven restaurant and craft beer spot for teams that want dinner, drinks, and easy conversation.',
    bestFor:
      'Casual office dinners, small team celebrations, client meals, and teams that want a simple restaurant-based outing.',
    details:
      'Wyoming Ale Works is a practical Casper listing for teams that need something familiar, comfortable, and easy to plan without a structured activity.',
    contact: 'https://www.wyomingaleworks.com/',
  },
  {
    id: 'denver-zoo-private-event',
    name: 'Denver Zoo Conservation Alliance',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$$$',
    groupSize: '25–300',
    duration: '2–4 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Social', 'Large group', 'Polished'],
    image: 'https://images.unsplash.com/photo-1574870111867-089730e5a72b?q=80&w=2187&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A memorable Denver event option with zoo venues, animal-centered atmosphere, and corporate event possibilities.',
    bestFor:
      'Large company events, employee appreciation nights, client events, and teams that want a distinctive Denver venue.',
    details:
      'Denver Zoo can work as a higher-impact company outing or private event, especially for groups that want a venue with built-in interest and strong guest appeal.',
    contact: 'https://denverzoo.org/private-events/',
  },
  {
    id: 'denver-botanic-gardens-private-event',
    name: 'Denver Botanic Gardens',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$$$',
    groupSize: '20–200',
    duration: '2–4 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Polished', 'Relaxed', 'Scenic'],
    image: 'https://images.unsplash.com/photo-1713383658268-6b9bd03beb19?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A scenic garden setting for team gatherings, receptions, and more polished corporate events.',
    bestFor:
      'Executive groups, client events, donor events, leadership teams, and companies that want an elegant outdoor feel.',
    details:
      'Denver Botanic Gardens is best for a more elevated outing where atmosphere matters. It can work for receptions, retreats, or a calmer social experience.',
    contact: 'https://www.botanicgardens.org/events/private-events',
  },
  {
    id: 'denver-cook-street-school',
    name: 'Cook Street School of Culinary Arts',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '8–80',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Hands-on', 'Social', 'Creative'],
    image: 'https://plus.unsplash.com/premium_photo-1683707120391-6c0da3cac6be?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A hands-on cooking class or private culinary event for teams that want food, collaboration, and conversation.',
    bestFor:
      'Client events, leadership groups, team celebrations, and companies that want a premium shared meal experience.',
    details:
      'Cook Street is a strong Denver option for teams that want the activity and meal combined. It can feel more special than a standard restaurant reservation.',
    contact: 'https://cookstreet.com/',
  },
  {
    id: 'denver-food-lab',
    name: 'Food Lab Denver',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '8–60',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Hands-on', 'Teamwork', 'Social'],
    image: 'https://images.unsplash.com/photo-1506368249639-73a05d6f6488?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A chef-guided cooking experience designed for corporate groups, client events, and hands-on team building.',
    bestFor:
      'Remote teams meeting in person, client events, leadership teams, and groups that want a true team-build format.',
    details:
      'Food Lab is positioned specifically around hands-on team building through cooking. It is a strong listing for companies that want something more collaborative than dinner.',
    contact: 'https://foodlabinc.com/denver/private-and-corporate-events',
  },
  {
    id: 'denver-taste-buds-kitchen-centennial',
    name: 'Taste Buds Kitchen Centennial',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '8–50',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Hands-on', 'Creative', 'Teamwork'],
    image: 'https://images.unsplash.com/photo-1672932727318-6c0291d4f0df?q=80&w=3135&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A corporate cooking-event option near Denver for teams that want camaraderie, food, and a guided class format.',
    bestFor:
      'Small to mid-size teams, employee appreciation events, and groups that like hands-on activities.',
    details:
      'Taste Buds Kitchen Centennial offers corporate cooking events that can serve as a structured team-building activity while still feeling relaxed and social.',
    contact: 'https://tastebudskitchen.com/centennial/corporate-cooking-events/',
  },
  {
    id: 'denver-game-show-battle-rooms',
    name: 'Game Show Battle Rooms Denver',
     active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$',
    groupSize: '8–64',
    duration: '1–1.5 hrs',
    setting: 'Indoor',
    vibe: ['Competitive', 'Funny', 'High energy'],
    image: 'https://images.unsplash.com/photo-1611996575749-79a3a250f948?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A live game-show style experience where coworkers compete in teams through fast, funny challenges.',
    bestFor:
      'Sales teams, startup teams, holiday parties, and groups that want an energetic indoor activity.',
    details:
      'Game Show Battle Rooms is a strong Denver-area option when the team wants something silly, competitive, and easy for almost everyone to participate in.',
    contact: 'https://gameshowbattlerooms.com/denver/',
  },
  {
    id: 'denver-empower-field-event',
    name: 'Empower Field at Mile High',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$$$',
    groupSize: '25–500',
    duration: '2–4 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Social', 'Memorable', 'Polished'],
    image: 'https://images.unsplash.com/photo-1688420797350-81c42896d092?q=80&w=3174&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A major Denver venue option for corporate events, team-building gatherings, picnics, and stadium-style experiences.',
    bestFor:
      'Large companies, client events, leadership conferences, employee appreciation events, and sports-adjacent teams.',
    details:
      'Empower Field works best for companies that want a recognizable Denver venue with space, catering, and event infrastructure already built in.',
    contact: 'https://www.empowerfieldatmilehigh.com/host-an-event',
  },
  {
    id: 'denver-the-lobby-corporate-events',
    name: 'The Lobby Denver',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '20–130',
    duration: '2–4 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Social', 'Outdoor', 'Flexible'],
    image: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A restaurant/event venue option with patio space that can support team-building, lawn games, and company socials.',
    bestFor:
      'Company lunches, patio events, casual happy hours, and teams that want food plus optional games.',
    details:
      'The Lobby is a useful Denver listing for planners who want a restaurant-based outing with more event structure than a simple reservation.',
    contact: 'https://thelobbydenver.com/corporate-events/',
  },
    {
    id: 'casper-boomtown-blast',
    name: 'Boomtown Blast Bowling & Arcade',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$',
    groupSize: '8–80',
    duration: '1.5–3 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Competitive', 'Food & drinks'],
    image:
      'https://images.unsplash.com/photo-1463411563105-157075b06f96?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A bowling and arcade outing with food, drinks, and easy built-in entertainment for mixed office groups.',
    bestFor:
      'Casual company socials, mixed-age teams, family-friendly events, and teams that want easy indoor fun.',
    details:
      'Boomtown Blast offers bowling lanes, arcade games, food, and bar/grill options. It is a practical Casper option for teams that want a flexible activity with minimal planning.',
    contact: 'https://boomtownblast.com/',
  },
  {
    id: 'casper-jump-craze',
    name: 'Jump Craze Indoor Trampoline Park',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Active',
    price: '$$',
    groupSize: '8–50',
    duration: '1–2 hrs',
    setting: 'Indoor',
    vibe: ['Active', 'Funny', 'High energy'],
    image:
      'https://images.unsplash.com/photo-1720217262963-088563b579d1?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'An indoor trampoline park outing for teams that want movement, laughter, and something more playful than dinner.',
    bestFor:
      'Younger teams, family-friendly company events, energetic groups, and casual employee appreciation outings.',
    details:
      'Jump Craze is an indoor trampoline park in Casper that mentions parties, corporate outings, and special events. It works best for active teams or family-inclusive events.',
    contact: 'https://www.jumpcrazeusa.com/',
  },
  {
    id: 'casper-pizza-ranch-funzone',
    name: 'Pizza Ranch FunZone Arcade',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$',
    groupSize: '10–60',
    duration: '1.5–2 hrs',
    setting: 'Indoor',
    vibe: ['Casual', 'Competitive', 'Easy planning'],
    image:
      'https://images.unsplash.com/photo-1604382355076-af4b0eb60143?auto=format&fit=crop&w=1200&q=80',
    summary:
      'A casual pizza-and-arcade outing that is simple to plan and approachable for almost any team.',
    bestFor:
      'Budget-conscious groups, family-friendly company parties, casual lunches, and teams that want something easy.',
    details:
      'Pizza Ranch FunZone Casper offers party options, private rooms for larger groups, food, and arcade play. It is a simple choice when the goal is low-stress fun.',
    contact: 'https://www.pizzaranchfunzone.com/party-packages/casper-wy',
  },
  {
    id: 'casper-frontier-brewing-company',
    name: 'Frontier Brewing Company and Taproom',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '6–40',
    duration: '1.5–2.5 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Local', 'Low pressure'],
    image:
      'https://images.unsplash.com/photo-1462664450306-25ad625a342b?q=80&w=1035&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A downtown Casper taproom outing with local beer, conversation, and a casual after-work feel.',
    bestFor:
      'Small teams, leadership groups, after-work socials, and adult teams that want something relaxed.',
    details:
      'Frontier Brewing Company and Taproom is a downtown Casper brewery option that can work well for informal team connection, post-meeting drinks, or a low-pressure office social.',
    contact:
      'https://travelwyoming.com/listing/frontier-brewing-company-and-taproom/2377/',
  },
  {
    id: 'casper-bull-horn-brewing',
    name: 'Bull Horn Brewing',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '6–50',
    duration: '1.5–2.5 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Food & drinks', 'Casual'],
    image:
      'https://images.unsplash.com/photo-1575037614876-c38a4d44f5b8?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A casual brewery and food stop for teams that want drinks, conversation, and an easy local gathering place.',
    bestFor:
      'After-work teams, small office celebrations, adult groups, and casual client meetups.',
    details:
      'Bull Horn Brewing is a Casper brewery option with food and drinks. It works well for a straightforward restaurant-style office outing.',
    contact: 'https://bullhornbrewing.beer/',
  },
  {
    id: 'casper-science-zone',
    name: 'The Science Zone',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '8–40',
    duration: '1.5–2 hrs',
    setting: 'Indoor',
    vibe: ['Educational', 'Creative', 'Hands-on', 'Family-friendly'],
    image:
      'https://images.unsplash.com/photo-1532094349884-543bc11b234d?auto=format&fit=crop&w=1200&q=80',
    summary:
      'A hands-on science museum option for teams that want something educational, playful, and different.',
    bestFor:
      'Education teams, family-friendly company events, science-minded teams, and smaller groups.',
    details:
      'The Science Zone offers museum exploration and room rental options. It is a good Casper option for a lower-cost outing that can include learning and hands-on exploration.',
    contact: 'https://thesciencezone.org/visit/birthday-parties',
  },
  {
    id: 'denver-k1-speed',
    name: 'K1 Speed Denver',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Active',
    price: '$$$',
    groupSize: '8–80',
    duration: '1.5–2.5 hrs',
    setting: 'Indoor',
    vibe: ['Competitive', 'High energy', 'Memorable'],
    image:
      'https://images.unsplash.com/photo-1595577586402-56e4612b6fa7?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'Indoor go-kart racing with custom race packages for teams that want speed, competition, and easy excitement.',
    bestFor:
      'Sales teams, startup teams, engineering groups, leadership events, and teams that like friendly competition.',
    details:
      'K1 Speed Denver offers indoor racing, food and drinks, a private meeting room, and corporate event options. It is a strong choice for a high-energy team outing.',
    contact: 'https://www.k1speed.com/denver-location.html',
  },
  {
    id: 'denver-curling-club',
    name: 'Denver Curling Club',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Active',
    price: '$$',
    groupSize: '8–60',
    duration: '1.5–2 hrs',
    setting: 'Indoor',
    vibe: ['Active', 'Collaborative', 'Seasonal'],
    image:
      'https://images.unsplash.com/photo-1644225797166-db7bba6f8a95?q=80&w=2073&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A learn-to-curl team outing that gives coworkers a unique shared challenge and plenty to laugh about.',
    bestFor:
      'Teams that want something unusual, winter outings, leadership groups, and companies that prefer collaboration over intense competition.',
    details:
      'Denver Curling Club hosts learn-to-curl clinics, corporate team-building events, and open houses. It is a memorable indoor option with a strong team component.',
    contact:
      'https://denvercurlingclub.com/index.php/curling/learn-to-curl-corporate',
  },
  {
    id: 'denver-immersive-gamebox',
    name: 'Immersive Gamebox Denver',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$',
    groupSize: '6–60',
    duration: '30–90 min',
    setting: 'Indoor',
    vibe: ['Competitive', 'Collaborative', 'Modern'],
    image:
      'https://images.unsplash.com/photo-1612287230202-1ff1d85d1bdf?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A tech-forward group gaming experience with motion tracking, projection mapping, and fast team challenges.',
    bestFor:
      'Small to mid-size teams, younger teams, remote teams meeting in person, and groups that want something modern.',
    details:
      'Immersive Gamebox Denver offers interactive group games and corporate/group event options. It is a good fit for teams that want something quick, different, and easy to understand.',
    contact: 'https://www.immersivegamebox.com/en-US/venues/dco-denver-colorado',
  },
  {
    id: 'denver-ace-eat-serve',
    name: 'Ace Eat Serve',
    active: false,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$$',
    groupSize: '20–130',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Food & drinks', 'Competitive'],
    image:
      'https://images.unsplash.com/photo-1534158914592-062992fbe900?auto=format&fit=crop&w=1200&q=80',
    summary:
      'A ping-pong, food, and drinks outing that feels social but still gives the team something active to do.',
    bestFor:
      'Company happy hours, client events, creative teams, and groups that want food plus light competition.',
    details:
      'Ace Eat Serve offers private ping-pong event space with food, drinks, and event support. It is a polished Denver option for teams that want a restaurant outing with an activity built in.',
    contact: 'https://www.aceeatserve.com/ping-pong-bar-denver/',
  },
  {
    id: 'denver-museum-nature-science',
    name: 'Denver Museum of Nature & Science',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$$',
    groupSize: '10–200',
    duration: '2–4 hrs',
    setting: 'Indoor',
    vibe: ['Educational', 'Relaxed', 'Large group'],
    image:
      'https://images.unsplash.com/photo-1617246405400-462cb1ab98ab?q=80&w=999&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A museum-based outing or event venue option with science exhibits, event spaces, and memorable group possibilities.',
    bestFor:
      'Professional teams, education groups, large companies, visiting teams, and groups that want a polished cultural experience.',
    details:
      'Denver Museum of Nature & Science offers group visit options and event spaces for corporate gatherings. It works well for teams that want a flexible, educational, and recognizable Denver outing.',
    contact: 'https://www.dmns.org/programs-and-events/host-an-event/',
  },
  {
    id: 'denver-forney-museum-transportation',
    name: 'Forney Museum of Transportation',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$$',
    groupSize: '10–150',
    duration: '1–3 hrs',
    setting: 'Indoor',
    vibe: ['Relaxed', 'Conversation-friendly', 'Local'],
    image:
      'https://images.unsplash.com/photo-1665055782689-52c91d46669d?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A transportation museum outing with vintage vehicles, historic artifacts, and private event possibilities.',
    bestFor:
      'History-minded teams, engineering teams, client events, nonprofit groups, and teams that want a distinctive venue.',
    details:
      'Forney Museum of Transportation offers event and meeting rental space and a large collection of transportation artifacts. It is a useful Denver option for a quiet but memorable group event.',
    contact: 'https://www.forneymuseum.org/MeetingRooms.html',
  },
  {
    id: 'denver-milk-market',
    name: 'Denver Milk Market',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '24–450',
    duration: '2–4 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Food & drinks', 'Large group'],
    image:
      'https://images.unsplash.com/photo-1438557068880-c5f474830377?q=80&w=1746&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A downtown food hall and private-event venue that can handle everything from team dinners to large company gatherings.',
    bestFor:
      'Large teams, client events, holiday parties, department socials, and groups that want many food options.',
    details:
      'Denver Milk Market offers private event space for groups from intimate gatherings to large-scale events. It is a strong choice when food variety and downtown location matter.',
    contact: 'https://www.denvermilkmarket.com/private-events/',
  },
  {
    id: 'denver-comedy-works-private-event',
    name: 'Comedy Works Private Event',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Entertainment',
    price: '$$$',
    groupSize: '20–200',
    duration: '1–3 hrs',
    setting: 'Indoor',
    vibe: ['Funny', 'Social', 'Memorable'],
    image:
      'https://images.unsplash.com/photo-1516280440614-37939bbacd81?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A private comedy-show or group comedy outing for teams that want laughter, entertainment, and a shared night out.',
    bestFor:
      'Company celebrations, holiday parties, client events, and teams that want entertainment without physical activity.',
    details:
      'Comedy Works offers private event options and is positioned for business functions, private parties, and events. It is a strong Denver choice for a team night centered on entertainment.',
    contact: 'https://comedyworks.com/pages/book-event',
  },
  {
    id: 'casper-the-lyric',
    name: 'The Lyric',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Entertainment',
    price: '$$$',
    groupSize: '20–250',
    duration: '2–4 hrs',
    setting: 'Indoor',
    vibe: ['Polished', 'Creative', 'Private event'],
    image: 'https://images.unsplash.com/photo-1503095396549-807759245b35?q=80&w=1742&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A downtown Casper event venue with theater spaces, a lobby area, and a creative setting for private gatherings.',
    bestFor:
      'Company presentations, team celebrations, nonprofit events, creative groups, and companies that want a more polished venue.',
    details:
      'The Lyric can work well for private events, team presentations, screenings, awards nights, or a creative company gathering in downtown Casper.',
    contact: 'https://www.visitcasper.com/directory/the-lyric/',
  },
  {
    id: 'casper-ford-wyoming-center',
    name: 'Ford Wyoming Center',
    active: true,
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Entertainment',
    price: '$$$',
    groupSize: '50–500',
    duration: '2–4 hrs',
    setting: 'Indoor',
    vibe: ['Large group', 'Memoriable', 'Event-style'],
    image: 'https://images.unsplash.com/photo-1607667730466-3fe37a1842ac?q=80&w=1742&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A large-scale Casper venue for concerts, performances, sporting events, rodeos, and major group gatherings.',
    bestFor:
      'Large companies, employee appreciation events, client events, holiday parties, and groups that want a bigger venue.',
    details:
      'Ford Wyoming Center is best for larger teams or companies that want to plan around an existing event or host a more formal private gathering.',
    contact: 'https://www.visitcasper.com/meetings/facilities/ford-wyoming-center/',
  },
  {
    id: 'casper-cadoma-foundation',
    name: 'Cadoma Foundation',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '6–40',
    duration: '1–2 hrs',
    setting: 'Indoor',
    vibe: ['Historic', 'Educational', 'Local'],
    image: 'https://images.unsplash.com/photo-1634500956474-9ebdb17e579d?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A small historic-house museum option for teams that want a quiet, local, inexpensive cultural outing.',
    bestFor:
      'Small offices, education teams, nonprofit groups, and teams that want a slower-paced local-history experience.',
    details:
      'Cadoma Foundation can work as a short cultural outing or a small private gathering, especially when paired with lunch or coffee afterward.',
    contact: 'https://cadomafoundation.org/',
  },
  {
    id: 'casper-skull-tree-brewing',
    name: 'Skull Tree Brewing',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '6–40',
    duration: '1.5–2.5 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Local', 'Casual'],
    image: 'https://images.unsplash.com/photo-1612528443702-f6741f70a049?q=80&w=1760&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A boutique Casper craft brewery for adult teams that want a relaxed local hangout and easy conversation.',
    bestFor:
      'After-work teams, small office celebrations, adult groups, and casual team socials.',
    details:
      'Skull Tree Brewing is a good fit when the outing does not need a formal activity, just a local place to gather, talk, and unwind.',
    contact: 'https://www.visitcasper.com/directory/skull-tree-brewing/',
  },
  {
    id: 'denver-chicken-n-pickle-thornton',
    name: 'Chicken N Pickle Thornton',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$$',
    groupSize: '20–150',
    duration: '2–3 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Active', 'Food & drinks', 'Social'],
    image: 'https://images.unsplash.com/photo-1734161081396-0f0572a16bf6?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A pickleball, yard-games, food, and drinks outing for teams that want movement plus a social atmosphere.',
    bestFor:
      'Company parties, active teams, client events, summer socials, and groups that want food with built-in games.',
    details:
      'Chicken N Pickle is a strong Denver-area option because it combines pickleball, full-service food and drinks, event spaces, and easy group planning.',
    contact: 'https://chickennpickle.com/thornton-private-events/',
  },
  {
    id: 'denver-flight-club',
    name: 'Flight Club Denver',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$$',
    groupSize: '13–150',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Competitive', 'Polished'],
    image: 'https://images.unsplash.com/photo-1704823822189-7a4cc1bc3fab?q=80&w=2104&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A tech-enabled Social Darts experience with food, cocktails, and private event spaces near Union Station.',
    bestFor:
      'Client events, happy hours, sales teams, executive assistants planning polished outings, and groups that want light competition.',
    details:
      'Flight Club Denver is a strong fit for teams that want a more elevated game-based outing with a built-in bar and private-event feel.',
    contact: 'https://www.flightclubdartsusa.com/denver/events',
  },
  {
    id: 'denver-american-axes',
    name: 'American Axes',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Team Building',
    price: '$$',
    groupSize: '6–80',
    duration: '1–2 hrs',
    setting: 'Indoor',
    vibe: ['Competitive', 'Memorable', 'Food hall nearby'],
    image: 'https://images.unsplash.com/photo-1706443841994-0c385ef6fa8f?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'An axe-throwing team-building option inside Edgewater Public Market with easy access to food and drinks nearby.',
    bestFor:
      'Small to mid-size teams, casual company socials, sales teams, and groups that want an easy tournament format.',
    details:
      'American Axes works well because the activity is structured, competitive, and close to food-hall options, which makes the whole outing easier to plan.',
    contact: 'https://american-axes.com/team-building-denver/',
  },
  {
    id: 'denver-all-out-smash',
    name: 'All Out Smash',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Active',
    price: '$$',
    groupSize: '4–40',
    duration: '1–2 hrs',
    setting: 'Indoor',
    vibe: ['High energy', 'Active', 'Stress relief'],
    image: 'https://images.unsplash.com/photo-1566937169390-7be4c63b8a0e?q=80&w=1738&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A rage-room and activity venue where teams can smash, splatter, throw axes, and do something completely different.',
    bestFor:
      'High-energy teams, staff appreciation outings, small groups, and coworkers who want an unusual shared experience.',
    details:
      'All Out Smash is best for teams that want something memorable and a little edgy rather than a quiet dinner or standard happy hour.',
    contact: 'https://www.alloutsmash.com/',
  },
  {
    id: 'denver-pindustry',
    name: 'Pindustry',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$$',
    groupSize: '20–300',
    duration: '2–4 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Large group', 'Social', 'Food & drinks'],
    image: 'https://images.unsplash.com/photo-1692554987643-2fb74a4fdccb?q=80&w=1548&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A large entertainment venue with bowling, games, food, drinks, live music, and flexible event options.',
    bestFor:
      'Large team outings, holiday parties, company celebrations, and groups that want multiple activity options in one place.',
    details:
      'Pindustry is a strong Denver-area option when planners need a venue that can handle bigger groups and offer more than one activity.',
    contact: 'https://www.thepindustry.com/private-parties',
  },
  {
    id: 'denver-uncorked-kitchen',
    name: 'Uncorked Kitchen & Wine Bar',
      active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '8–48',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Hands-on', 'Social', 'Polished'],
    image: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A private cooking-event option where teams cook, eat, and connect through a shared culinary experience.',
    bestFor:
      'Client events, leadership teams, remote teams meeting in person, and groups that want something more interactive than dinner.',
    details:
      'Uncorked Kitchen is a good fit for teams that want a guided private cooking event with a more polished food-and-wine atmosphere.',
    contact: 'https://www.uncorkedkitchen.com/private-cooking-events',
  },
  {
    id: 'denver-graffiti-tour',
    name: 'Denver Graffiti Tour',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$$',
    groupSize: '8–70',
    duration: '2 hrs',
    setting: 'Outdoor',
    vibe: ['Creative', 'Local', 'Walking tour'],
    image: 'https://images.unsplash.com/photo-1581850518616-bcb8077a2336?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A private RiNo street-art and mural tour for teams that want local culture, walking, conversation, and a creative Denver feel.',
    bestFor:
      'Visiting teams, creative teams, client groups, conference attendees, and companies that want a low-pressure cultural outing.',
    details:
      'Denver Graffiti Tour works well for groups that want something active but not athletic. It also pairs easily with drinks, food halls, or a brewery stop afterward.',
    contact: 'https://www.denvergraffititour.com/private-tours',
  },
  {
    id: 'denver-lucky-to-ride-bike-build',
    name: 'Lucky To Ride Corporate Bike Build',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings', 'volunteer'],
    category: 'Purpose-Driven',
    price: '$$$',
    groupSize: '10–200',
    duration: '2–3 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Purpose-driven', 'Collaborative', 'Community impact'],
    image: 'https://images.unsplash.com/photo-1673870861521-626b40f9657e?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A philanthropic team-building activity where coworkers build bikes that benefit underserved youth in the Denver metro area.',
    bestFor:
      'Companies that want service-based team building, leadership retreats, values-driven teams, and employee engagement events.',
    details:
      'Lucky To Ride is a strong listing for companies that want an outing with a community-impact angle rather than a purely recreational event.',
    contact: 'https://luckytoride.org/bike_build/',
  },
   {
    id: 'casper-mountain-trails-center',
    name: 'Casper Mountain Trails Center',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$',
    groupSize: '8–60',
    duration: '1.5–3 hrs',
    setting: 'Outdoor',
    vibe: ['Active', 'Scenic', 'Low pressure'],
    image:
      'https://images.unsplash.com/photo-1562593028-1fe2d15bde36?q=80&w=928&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A scenic Casper Mountain outing with hiking, biking, snowshoeing, or Nordic skiing depending on the season.',
    bestFor:
      'Teams that want fresh air, wellness, casual conversation, and a budget-friendly outdoor reset.',
    details:
      'Casper Mountain Trails Center is a good fit for a low-cost wellness outing. Plan a short hike, snowshoe walk, or casual trail day, then pair it with lunch or coffee afterward.',
    contact: 'https://www.visitcasper.com/directory/casper-mountain-trails-center/',
  },
  {
    id: 'casper-historic-trails-west',
    name: 'Historic Trails West Wagon Trek',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$$$',
    groupSize: '8–40',
    duration: '2–3 hrs',
    setting: 'Outdoor',
    vibe: ['Active', 'Memorable', 'Uniquely Wyoming'],
    image:
      'https://images.unsplash.com/photo-1603051858470-bb3ea2689f44?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A covered-wagon history experience along the Oregon Trail ruts for teams that want something distinctly Casper.',
    bestFor:
      'Visiting teams, leadership retreats, client groups, education teams, and companies that want a memorable local outing.',
    details:
      'Historic Trails West offers living-history wagon experiences near Casper. This is one of the strongest “only in Wyoming” options for a group that wants more than a standard activity.',
    contact: 'https://www.historictrailswest.com/historictrailstours',
  },
  {
    id: 'casper-cnfr-rodeo-night',
    name: 'College National Finals Rodeo Night',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Entertainment',
    price: '$$',
    groupSize: '10–100',
    duration: '2–4 hrs',
    setting: 'Indoor',
    vibe: ['Show', 'High energy', 'Western'],
    image:
      'https://images.unsplash.com/photo-1726534609988-c0feeeb77df0?q=80&w=2152&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A seasonal rodeo-night outing during CNFR week for teams that want a true Wyoming experience.',
    bestFor:
      'Visiting teams, summer events, client groups, larger office outings, and companies that want something lively and local.',
    details:
      'Casper hosts the College National Finals Rodeo each June. For the right timing, this could be a memorable group night built around western culture, competition, and an easy shared experience.',
    contact: 'https://www.visitcasper.com/blog/things-to-do-in-casper-during-cnfr-week/',
  },
  {
    id: 'casper-north-platte-fly-fishing',
    name: 'North Platte River Fly-Fishing Outing',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$$$',
    groupSize: '4–20',
    duration: 'Half day',
    setting: 'Outdoor',
    vibe: ['Scenic', 'Relaxed', 'Premium'],
    image:
      'https://images.unsplash.com/photo-1598551729246-dffb58e2a662?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A guided fly-fishing style outing for smaller teams that want a slower, scenic, premium outdoor experience.',
    bestFor:
      'Leadership teams, client entertainment, executive retreats, and small groups that prefer calm outdoor activities.',
    details:
      'The North Platte River is a strong Casper-area outdoor draw. This listing works best as a premium small-group concept that can be booked through local guides or outfitters.',
    contact: 'https://www.visitcasper.com/meetings/group-activities/',
  },
  {
    id: 'casper-alcova-reservoir-day',
    name: 'Alcova Reservoir Group Day',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$$$',
    groupSize: '8–40',
    duration: 'Half day',
    setting: 'Outdoor',
    vibe: ['Scenic', 'Summer', 'Active', 'Memorable'],
    image:
      'https://images.unsplash.com/photo-1615551043360-33de8b5f410c?q=80&w=1752&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A summer lake outing near Casper with water views, small-group cruising, or a relaxed outdoor gathering.',
    bestFor:
      'Summer employee appreciation, leadership groups, client outings, and teams that want a scenic outdoor experience.',
    details:
      'Alcova Reservoir is a strong nearby option for companies that want a destination-style outing without going far from Casper. It can work as a half-day retreat or summer social.',
    contact: 'https://www.visitcasper.com/blog/take-your-meeting-outside-in-casper-wyoming/',
  },
  {
    id: 'casper-central-wyoming-fair-rodeo',
    name: 'Central Wyoming Fair & Rodeo',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Entertainment',
    price: '$$',
    groupSize: '10–150',
    duration: '2–4 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Seasonal', 'Western', 'Show', 'Large group'],
    image:
      'https://images.unsplash.com/photo-1600996529650-8bd7260dda2b?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A seasonal fair-and-rodeo outing for teams that want food, energy, entertainment, and a Wyoming feel.',
    bestFor:
      'Large teams, family-friendly company nights, summer socials, and groups that want an easy shared event.',
    details:
      'The Central Wyoming Fair & Rodeo can be a strong seasonal group outing when companies want a built-in event instead of planning every activity from scratch.',
    contact: 'https://www.visitcasper.com/meetings/group-activities/',
  },
  {
    id: 'denver-dave-and-busters',
    name: "Dave & Buster's Denver",
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Games',
    price: '$$',
    groupSize: '10–200',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Competitive', 'Food & drinks', 'Easy planning'],
    image:
      'https://images.unsplash.com/photo-1541474583361-bc9527eb46d6?q=80&w=1114&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A familiar arcade, sports-bar, and restaurant outing with corporate event options and easy group planning.',
    bestFor:
      'Mixed teams, casual company socials, happy hours, holiday parties, and groups that want a simple indoor option.',
    details:
      'Dave & Buster’s is a practical Denver listing because it combines food, games, screens, and group-event support in one place.',
    contact: 'https://www.daveandbusters.com/us/en/celebrate/bookings',
  },
  {
    id: 'denver-stir-cooking-school',
    name: 'Stir Cooking School',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '8–75',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Hands-on', 'Creative', 'Team building'],
    image:
      'https://images.unsplash.com/photo-1547592180-85f173990554?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A hands-on cooking school experience with team-building cooking games, private events, and flexible formats.',
    bestFor:
      'Leadership teams, client events, remote teams meeting in person, and groups that want food plus collaboration.',
    details:
      'Stir Cooking School is a strong Denver option because it can turn the meal itself into the activity. It works well for teams that want something interactive but still polished.',
    contact: 'https://www.stirtolearn.com/private-events',
  },
  {
    id: 'denver-whiskey-hitch-cocktail-class',
    name: 'Whiskey Hitch Mobile Cocktail Class',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '10+ (confirm with the instructor)',
    duration: '1.5–2 hrs',
    setting: 'At your office / Your venue',
    vibe: ['Hands-on', 'Social', 'Creative'],
    image: categoryImages.foodAndDrinks,
    summary:
      'A mobile, instructor-led cocktail class that comes to your office or venue with bar kits, mixers, and glassware.',
    bestFor:
      'Happy hours, client events, and teams that want a social, hands-on activity without leaving the office.',
    details:
      'Whiskey Hitch publishes its pricing: $25 per cocktail per person with a $500 class minimum. Your group supplies the spirits and the space.',
    contact: 'https://whiskeyhitch.com/cocktail-classes',
  },
  {
    id: 'denver-cozymeal-team-cooking',
    name: 'Cozymeal Team Cooking Class',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '2+ (varies by chef)',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Hands-on', 'Teamwork', 'Social'],
    image: categoryImages.foodAndDrinks,
    summary:
      'Chef-led team cooking classes from Denver chefs, booked through Cozymeal with ingredients and the meal included.',
    bestFor:
      'Teams that want a cooking class with a clearly listed per-person price.',
    details:
      'Cozymeal lists Denver team cooking classes at $85–$115 per person. The exact price depends on the chef and menu.',
    contact: 'https://www.cozymeal.com/denver/cooking-classes/group',
  },
  {
    id: 'denver-pedal-hopper',
    name: 'Pedal Hopper Denver',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '6–112',
    duration: '2 hrs',
    setting: 'Outdoor',
    vibe: ['Social', 'Funny', 'Adults only'],
    image:
      'https://images.unsplash.com/photo-1773682263317-d8ce03c8e0e2?q=80&w=2232&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A pedal-powered Denver pub crawl for teams that want a funny, social, outdoor group activity.',
    bestFor:
      'Adult teams, casual celebrations, younger teams, conference groups, and companies that want something lighthearted.',
    details:
      'Pedal Hopper offers private and corporate bike-bar tours and can scale up for larger all-staff corporate pub crawls. This is best for teams comfortable with a casual bar-hop style event.',
    contact: 'https://www.pedalhopper.com/denver/corporate-events/',
  },
  {
    id: 'denver-movement-climbing-party',
    name: 'Movement Climbing Party',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Active',
    price: '$$',
    groupSize: '6–40',
    duration: '1.5–2 hrs',
    setting: 'Indoor',
    vibe: ['Active', 'Confidence-building', 'Collaborative'],
    image:
      'https://images.unsplash.com/photo-1696105539018-a73a53770934?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'An indoor climbing outing with instructor support for teams that want movement, challenge, and a shared new experience.',
    bestFor:
      'Small teams, adventurous groups, wellness outings, and companies that want an active but weather-proof option.',
    details:
      'Movement offers climbing parties for birthdays, team-building, corporate outings, and special events. It is a good fit for teams that want something active without needing advanced climbing experience.',
    contact: 'https://movementgyms.com/climbing-parties/',
  },
  {
    id: 'denver-urban-air-adventure-park',
    name: 'Urban Air Denver East',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Active',
    price: '$$',
    groupSize: '10–100',
    duration: '1.5–3 hrs',
    setting: 'Indoor',
    vibe: ['High energy', 'Active', 'Family-friendly'],
    image:
      'https://images.unsplash.com/photo-1682334863932-c746daff7cd9?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'An indoor adventure-park outing with attractions, group-event options, and customizable corporate team-building formats.',
    bestFor:
      'Active teams, family-friendly company events, employee appreciation outings, and groups that want a playful indoor venue.',
    details:
      'Urban Air is useful for teams that want lots of movement and multiple attractions in one location. It can work especially well for employee events that include families.',
    contact: 'https://www.urbanair.com/group-events/corporate-events-team-building/',
  },
  {
    id: 'denver-colorado-adventure-center',
    name: 'Colorado Adventure Center',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$$$',
    groupSize: '8–100',
    duration: 'Half day',
    setting: 'Outdoor',
    vibe: ['Adventure', 'Active', 'Memorable'],
    image:
      'https://images.unsplash.com/photo-1648853070657-6d58398bee93?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A near-Denver outdoor adventure option with rafting, ziplining, and aerial challenge experiences for groups.',
    bestFor:
      'Adventurous teams, leadership retreats, summer outings, conference add-ons, and companies that want a bigger experience.',
    details:
      'Colorado Adventure Center is near Idaho Springs and offers rafting, zipline, and aerial adventure options for groups. This is best for a team willing to leave the city for a memorable outdoor day.',
    contact: 'https://www.raftingcolorado.com/',
  },
  {
    id: 'denver-corporate-cooking-classes',
    name: 'Denver Cooking Classes',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '8–50',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Hands-on', 'Creative', 'Flexible'],
    image:
      'https://images.unsplash.com/photo-1514986888952-8cd320577b68?q=80&w=1752&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'Chef-guided cooking classes that bring teams together through food, collaboration, and a shared finished meal.',
    bestFor:
      'Small to mid-size teams, client events, leadership groups, and teams that want an activity built around food.',
    details:
      'Denver Cooking Classes offers corporate team-building cooking classes and can tailor the experience to the group. It is a good option when the team wants something interactive but not too physically active.',
    contact: 'https://denvercookingclasses.com/corporate-cooking-classes/',
  },
   {
    id: 'casper-black-tooth-brewing',
    name: 'Black Tooth Brewing Casper',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '6–50',
    duration: '1.5–2.5 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Local', 'Low pressure'],
    image:
      'https://images.unsplash.com/photo-1584225064536-d0fbc0a10f18?q=80&w=1548&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A downtown Casper brewery outing with local beer, rotating events, and a relaxed social atmosphere.',
    bestFor:
      'After-work socials, small team celebrations, adult teams, and casual client meetups.',
    details:
      'Black Tooth Brewing is a good option when the goal is simple: give coworkers a local place to gather, talk, and unwind without building a complicated event schedule.',
    contact: 'https://www.blacktoothbrewingcompany.com/',
  },
  {
    id: 'casper-oil-city-beer-company',
    name: 'Oil City Beer Company',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '8–100',
    duration: '1.5–3 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Live music', 'Casual'],
    image:
      'https://images.unsplash.com/photo-1595600566063-2863388012be?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A Casper brewery and event-style hangout with local beer, games, music, food trucks, and group-friendly energy.',
    bestFor:
      'Casual office parties, adult team socials, employee appreciation nights, and groups that want music or games.',
    details:
      'Oil City Beer Company can work well for a low-pressure team night where coworkers can grab drinks, listen to music, play games, and stay as long as they want.',
    contact: 'https://www.oilcitybeer.com/',
  },
  {
    id: 'casper-wyoming-veterans-memorial-museum',
    name: 'Wyoming Veterans Memorial Museum',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '8–50',
    duration: '1–2 hrs',
    setting: 'Indoor',
    vibe: ['Historic', 'Educational', 'Reflective'],
    image:
      'https://images.unsplash.com/photo-1464660756002-dd9f9a92b01b?q=80&w=1702&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A meaningful museum visit focused on military history, service, and Wyoming veterans.',
    bestFor:
      'Leadership teams, government groups, education teams, veterans-connected organizations, and quieter cultural outings.',
    details:
      'The Wyoming Veterans Memorial Museum is a good fit for teams that want a low-cost, thoughtful outing with local significance. It could pair well with lunch or a short leadership discussion afterward.',
    contact:
      'https://www.wyomilitary.wyo.gov/resources/veteran/museums/wy-veterans-memorial-museum/',
  },
  {
    id: 'casper-werner-wildlife-museum',
    name: 'Werner Wildlife Museum',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '6–40',
    duration: '1–1.5 hrs',
    setting: 'Indoor',
    vibe: ['Educational', 'Wildlife', 'Low pressure'],
    image:
      'https://images.unsplash.com/photo-1504173010664-32509aeebb62?auto=format&fit=crop&w=1200&q=80',
    summary:
      'A free wildlife museum outing with Wyoming-focused displays and group activities available by appointment.',
    bestFor:
      'Education teams, family-friendly office events, science-minded teams, and small groups that want something quiet and inexpensive.',
    details:
      'Werner Wildlife Museum is a simple Casper option for teams that want a short cultural stop, especially when paired with coffee, lunch, or another nearby activity.',
    contact: 'https://www.caspercollege.edu/werner-wildlife-museum/',
  },
  {
    id: 'casper-wind-river-wraiths-ghost-tour',
    name: 'Wind River Wraiths Ghost Tour',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Entertainment',
    price: '$$',
    groupSize: '6–30',
    duration: '1.5–2 hrs',
    setting: 'Outdoor',
    vibe: ['Storytelling', 'Unique', 'After-hours'],
    image: 'https://images.unsplash.com/photo-1530605290309-ebfe523e6605?q=80&w=1548&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A spooky walking-tour style outing that blends local history, storytelling, and a memorable after-hours experience.',
    bestFor:
      'Small teams, visiting groups, seasonal fall outings, and coworkers who want something unusual but not physically intense.',
    details:
      'This is a strong Casper listing for teams that want an experience people will talk about afterward. It works especially well around Halloween or as an evening add-on after dinner.',
    contact:
      'https://travelwyoming.com/listing/wind-river-wraiths%3A-chilling-casper-ghost-tour/2836/',
  },
  {
    id: 'casper-west-fork-event-venue',
    name: 'West Fork',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$$$',
    groupSize: '20–150',
    duration: '2–4 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Scenic', 'Social', 'Private event', 'Polished'],
    image:
      'https://images.unsplash.com/photo-1567435025579-21f869a7b9ff?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A Casper Mountain event venue option for companies that want views, a private setting, and a more elevated gathering.',
    bestFor:
      'Company parties, leadership retreats, client events, holiday events, and groups that want a venue rather than an activity.',
    details:
      'West Fork works best for teams that want a scenic private-event atmosphere. It could support a catered company party, retreat-style gathering, or special celebration.',
    contact: 'https://westforkwyoming.com/',
  },
  {
    id: 'casper-family-aquatic-center',
    name: 'Casper Family Aquatic Center',
    city: 'Casper',
    state: 'WY',
    primaryCategories: ['outings'],
    category: 'Active',
    price: '$',
    groupSize: '10–60',
    duration: '1.5–2.5 hrs',
    setting: 'Indoor',
    vibe: ['Family-friendly', 'Active', 'Casual'],
    image:
      'https://images.unsplash.com/photo-1498747946579-bde604cb8f44?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'An indoor pool and waterpark option with slides, lap pool areas, hot tubs, and a family-friendly atmosphere.',
    bestFor:
      'Family-inclusive company events, casual staff appreciation outings, youth-serving organizations, and active teams.',
    details:
      'Casper Family Aquatic Center is a practical low-cost option when a company wants an easy indoor activity, especially for events that include employees’ families.',
    contact:
      'https://www.visitcasper.com/directory/casper-family-aquatic-center/',
  },
  {
    id: 'denver-denver-beer-co-private-event',
    name: 'Denver Beer Co. Private Event',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '10–150',
    duration: '1.5–3 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Social', 'Local', 'Easy planning'],
    image:
      'https://images.unsplash.com/photo-1504502350688-00f5d59bbdeb?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A flexible brewery outing with multiple taprooms, private-event options, and an easygoing Denver feel.',
    bestFor:
      'Happy hours, team celebrations, department socials, client meetups, and adult groups that want a casual venue.',
    details:
      'Denver Beer Co. is a strong option for planners who want great beer, flexible spaces, and a social environment without building an activity from scratch.',
    contact: 'https://denverbeerco.com/private-events/',
  },
  {
    id: 'denver-woods-boss-brewing-event',
    name: 'Woods Boss Brewing Company',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '10–100',
    duration: '1.5–3 hrs',
    setting: 'Indoor',
    vibe: ['Rustic', 'Social', 'Local'],
    image:
      'https://images.unsplash.com/photo-1625264412785-7c94942908a5?q=80&w=1933&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3Dhttps://images.unsplash.com/photo-1625264412785-7c94942908a5?q=80&w=1933&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A downtown Denver brewery with private-party and reserved-section options for casual corporate gatherings.',
    bestFor:
      'After-work socials, nonprofit teams, casual company parties, and groups that want a relaxed taproom environment.',
    details:
      'Woods Boss Brewing works well for teams that want a warm, rustic taproom feel with enough structure to reserve space for a group.',
    contact: 'https://www.woodsbossbrewing.com/host-an-event',
  },
  {
    id: 'denver-mile-high-spirits',
    name: 'Mile High Spirits',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$$',
    groupSize: '10–150',
    duration: '1.5–3 hrs',
    setting: 'Indoor',
    vibe: ['Cocktails', 'Social', 'Adults only'],
    image:
      'https://images.unsplash.com/photo-1508253730651-e5ace80a7025?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A downtown Denver cocktail-bar and distillery outing with tasting-room energy, cocktails, and private-event potential.',
    bestFor:
      'Adult team socials, client events, executive assistants planning polished happy hours, and celebration nights.',
    details:
      'Mile High Spirits is a strong option when the team wants something more elevated than a standard bar but still social and easy to plan.',
    contact: 'https://drinkmhs.com/tasting-room',
  },
  {
    id: 'denver-coors-field-group-outing',
    name: 'Coors Field Group Outing',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Entertainment',
    price: '$$$',
    groupSize: '20–300',
    duration: '3–4 hrs',
    setting: 'Outdoor',
    vibe: ['Sports', 'Large group', 'Social'],
    image:
      'https://images.unsplash.com/photo-1475440197469-e367ec8eeb19?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A Colorado Rockies group-ticket outing for teams that want baseball, social time, and an easy shared Denver experience.',
    bestFor:
      'Large teams, summer outings, client groups, employee appreciation events, and companies that want a built-in event.',
    details:
      'Coors Field works well for office outings because the entertainment is already planned. Groups can add food value or choose special group areas depending on size and budget.',
    contact: 'https://www.mlb.com/rockies/tickets/group-tickets/information',
  },
  {
    id: 'denver-dinosaur-ridge-group-tour',
    name: 'Dinosaur Ridge Group Tour',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '10–60',
    duration: '1–2.5 hrs',
    setting: 'Outdoor',
    vibe: ['Educational', 'Walking tour', 'Unique'],
    image:
      'https://images.unsplash.com/photo-1525877442103-5ddb2089b2bb?auto=format&fit=crop&w=1200&q=80',
    summary:
      'A geology and dinosaur-track outing near Denver for teams that want something educational, outdoorsy, and different.',
    bestFor:
      'Education teams, science-minded groups, visiting teams, family-friendly outings, and teams that enjoy walking tours.',
    details:
      'Dinosaur Ridge can be a great low-cost group outing near Denver. It is especially useful for teams that want an educational outdoor activity without a strenuous adventure.',
    contact: 'https://dinoridge.org/programs-and-events/school-group-programs/',
  },
  {
    id: 'denver-prost-biergarten-private-event',
    name: 'Prost Biergarten Private Event',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Food & Drinks',
    price: '$$',
    groupSize: '10–120',
    duration: '1.5–3 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Social', 'Beer hall', 'Casual'],
    image:
      'https://images.unsplash.com/photo-1515723959262-56195aae7cdd?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A German-style biergarten outing with private-event options for casual team socials and company celebrations.',
    bestFor:
      'Team happy hours, casual client events, adult groups, and companies that want a relaxed beer-hall atmosphere.',
    details:
      'Prost is a good fit for groups that want a casual, social event with food, beer, and plenty of room to mingle.',
    contact: 'https://www.prostbrewing.com/private-events',
  },
   {
    id: 'denver-hammonds-candies-factory-tour',
    name: "Hammond's Candies Factory Tour",
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '6–30',
    duration: '30–45 min',
    setting: 'Indoor',
    vibe: ['Social', 'Family-friendly', 'Unique'],
    image:
      'https://images.unsplash.com/photo-1633158832466-be592c721217?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A free candy factory tour that gives teams a short, cheerful outing with samples and behind-the-scenes production.',
    bestFor:
      'Budget-conscious teams, family-friendly groups, visiting employees, and companies that want a quick low-pressure outing.',
    details:
      'Hammond’s Candies offers complimentary factory tours in Denver. This works best as a short daytime outing, especially when paired with lunch, coffee, or another nearby stop.',
    contact: 'https://hammondscandies.com/pages/factory-tours-new',
  },
  {
    id: 'denver-mint-tour',
    name: 'Denver Mint Tour',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '5–15',
    duration: '1 hr',
    setting: 'Indoor',
    vibe: ['Unique', 'Relaxed', 'Educational', 'Low pressure'],
    image:
      'https://images.unsplash.com/photo-1744130400729-c4aee523f490?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A free tour of the U.S. Mint in Denver for teams that want something historic, unusual, and easy on the budget.',
    bestFor:
      'Small teams, finance teams, visiting employees, leadership groups, and teams that want an educational outing.',
    details:
      'Denver Mint tours are free but require planning because tickets are limited and availability can change. This is best for smaller teams that can reserve ahead.',
    contact: 'https://www.usmint.gov/about/tours-and-locations/denver/tour-denver-mint',
  },
  {
    id: 'denver-colorado-state-capitol-tour',
    name: 'Colorado State Capitol Tour',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '10–35',
    duration: '1 hr',
    setting: 'Indoor',
    vibe: ['Educational', 'Relaxed', 'Local'],
    image:
      'https://images.unsplash.com/photo-1587096085496-2d0e48bc8ac1?q=80&w=2710&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A free guided tour of the Colorado State Capitol for teams that want history, architecture, and a downtown Denver experience.',
    bestFor:
      'Government teams, nonprofit teams, visiting employees, education groups, and budget-conscious office outings.',
    details:
      'The Capitol offers free tours, with reservations recommended or required for larger groups. It pairs easily with lunch downtown or a short walk through Civic Center Park.',
    contact: 'https://content.leg.colorado.gov/content/tour-information',
  },
  {
    id: 'denver-red-rocks-self-guided-tour',
    name: 'Red Rocks Self-Guided Tour',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$',
    groupSize: '6–40',
    duration: '1–2 hrs',
    setting: 'Outdoor',
    vibe: ['Active', 'Outdoor', 'Scenic'],
    image:
      'https://images.unsplash.com/photo-1701919747996-1e9531dde0a9?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A free self-guided visit to Red Rocks for teams that want fresh air, views, light walking, and a memorable Colorado setting.',
    bestFor:
      'Active teams, visiting employees, wellness outings, budget-conscious groups, and teams that want photos and scenery.',
    details:
      'Red Rocks Park and Amphitheatre offers free self-guided tours when the venue is open to the public. It works well as a morning or early afternoon outing before a meal nearby.',
    contact: 'https://www.redrocksonline.com/plan-your-visit/tours/',
  },
  {
    id: 'denver-colorado-sports-hall-of-fame',
    name: 'Colorado Sports Hall of Fame Museum',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '6–40',
    duration: '45–90 min',
    setting: 'Indoor',
    vibe: ['Social', 'Sports', 'Low pressure'],
    image:
      'https://images.unsplash.com/photo-1673305414273-307a1fe7e959?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A free sports-history museum at Empower Field for teams that want a quick Denver outing without a big spend.',
    bestFor:
      'Sports fans, casual teams, visiting employees, and groups looking for a short indoor activity.',
    details:
      'The Colorado Sports Hall of Fame museum is free of charge. Teams can keep it inexpensive with the museum only, or add a paid stadium tour if budget allows.',
    contact: 'https://www.coloradosports.org/',
  },
  {
    id: 'denver-city-park-picnic-games',
    name: 'City Park Picnic & Lawn Games',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$',
    groupSize: '15–100',
    duration: '2–3 hrs',
    setting: 'Outdoor',
    vibe: ['Relaxed', 'Social', 'Family-friendly'],
    image:
      'https://images.unsplash.com/photo-1716582873749-f4fb77fe9957?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A budget-friendly team picnic with lawn games, simple food, and flexible outdoor space in one of Denver’s classic parks.',
    bestFor:
      'Large teams, family-friendly company gatherings, summer socials, and companies trying to keep costs low.',
    details:
      'Denver picnic sites can be reserved by permit, making this a simple low-cost option. Add catered sandwiches, cornhole, trivia, or team awards to make it feel organized.',
    contact: 'https://www.denvergov.org/Government/Agencies-Departments-Offices/Agencies-Departments-Offices-Directory/Parks-Recreation/Park-Permits/Picnic-Permits',
  },
  {
    id: 'denver-public-library-team-room',
    name: 'Denver Public Library Team Room',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Workspace',
    price: '$',
    groupSize: '4–20',
    duration: '1–3 hrs',
    setting: 'Indoor',
    vibe: ['Relaxed', 'Creative', 'Low pressure'],
    image:
      'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?auto=format&fit=crop&w=1200&q=80',
    summary:
      'A free meeting-room option for teams that need a quiet place to brainstorm, plan, or run a low-cost offsite.',
    bestFor:
      'Small teams, nonprofit groups, planning sessions, book-club style discussions, and budget-conscious offsites.',
    details:
      'Denver Public Library branch meeting spaces can be reserved free of charge for qualifying groups. This is best for teams that want a quiet planning session followed by lunch or coffee nearby.',
    contact: 'https://www.denverlibrary.org/meeting-spaces',
  },
  {
    id: 'denver-food-bank-rockies-group-volunteer',
    name: 'Food Bank of the Rockies Group Volunteer Day',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings', 'volunteer'],
    category: 'Purpose-Driven',
    price: '$',
    groupSize: '5–50',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Purpose-driven', 'Community', 'Hunger Relief', 'Community impact'],
    image:
      'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1200&q=80',
    summary:
      'A meaningful group volunteer outing where coworkers help support hunger relief in the Denver area.',
    bestFor:
      'Companies with volunteer time off, HR teams, values-driven groups, and teams that want a service-based outing.',
    details:
      'Food Bank of the Rockies supports group volunteer experiences for companies and organizations. It is a strong low-cost option when the goal is connection and community impact.',
    contact: 'https://www.foodbankrockies.org/get-involved/volunteer/groups/',
  },
  {
    id: 'denver-project-cure-group-volunteer',
    name: 'Project C.U.R.E. Group Volunteer Day',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings', 'volunteer'],
    category: 'Purpose-Driven',
    price: '$',
    groupSize: '5–150',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Purpose-driven', 'Community', 'Youth', 'Hands-on'],
    image:
      'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?auto=format&fit=crop&w=1200&q=80',
    summary:
      'A hands-on volunteer outing where teams sort and prepare donated medical supplies for communities in need.',
    bestFor:
      'Healthcare teams, corporate volunteer days, leadership groups, and companies that want a purpose-driven team activity.',
    details:
      'Project C.U.R.E. offers group volunteering for companies and community groups. It is a strong Denver-area option for teams that want impact, structure, and hands-on participation.',
    contact: 'https://projectcure.org/group-volunteering/',
  },
  {
    id: 'denver-park-trust-cleanup-day',
    name: 'Denver Park Trust Company Volunteer Day',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings', 'volunteer'],
    category: 'Purpose-Driven',
    price: '$',
    groupSize: '5–100',
    duration: '2–3 hrs',
    setting: 'Outdoor',
    vibe: ['Purpose-driven', 'Community', 'Environment', 'Outdoor'],
    image:
      'https://images.unsplash.com/photo-1559027615-cd4628902d4a?q=80&w=1748&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A custom park cleanup or stewardship day for teams that want fresh air and community impact.',
    bestFor:
      'Companies with volunteer time off, sustainability-minded teams, large departments, and groups that want an outdoor service project.',
    details:
      'Denver Park Trust can help coordinate company volunteer days in Denver parks, including cleanups and other park-support projects depending on season and need.',
    contact: 'https://denverparktrust.org/plan-a-company-volunteer-day/',
  },
  {
    id: 'denver-tool-library-private-workshop',
    name: 'Denver Tool Library Private Workshop',
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings', 'volunteer'],
    category: 'Creative',
    price: '$',
    groupSize: '6–20',
    duration: '2–3 hrs',
    setting: 'Indoor',
    vibe: ['Creative', 'Team building', 'community', 'Hands-on'],
    image:
      'https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&w=1200&q=80',
    summary:
      'A hands-on making or woodworking-style outing through a nonprofit community workshop.',
    bestFor:
      'Creative teams, small departments, hands-on learners, and groups that want something more memorable than lunch.',
    details:
      'Denver Tool Library offers private classes and group workshop options. It is a good lower-cost creative outing compared with many private entertainment venues.',
    contact: 'https://denvertoollibrary.org/private-classes',
  },
  {
    id: 'denver-rino-country-club',
  name: 'RiNo Country Club Mini Golf',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['outings'],
  category: 'Active Games',
  price: '$',
  groupSize: '6–30',
  duration: '1–2 hrs',
  setting: 'Outdoor',
  vibe: ['Competitive', 'Casual', 'Budget-friendly'],
  image:
    'https://images.unsplash.com/photo-1567019001814-57350903e2af?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'A casual mini golf and bar outing in RiNo that works well for teams that want something inexpensive, social, and lightly competitive.',
  bestFor:
    'Small teams, casual happy hours, newer coworkers, and groups that want a low-pressure activity with built-in competition.',
  details:
    'This is one of the strongest budget-friendly Denver options because mini golf is simple, social, and easy for mixed groups. Best for adult teams that want a casual outing rather than a formal team-building event.',
  contact: 'https://www.rinocc.com/',
},
  {
  id: 'casper-ice-arena-public-skate',
  name: 'Casper Ice Arena Public Skate',
  active: false,
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['outings'],
  category: 'Active Games',
  price: '$',
  groupSize: '6–30',
  duration: '1–2 hrs',
  setting: 'Indoor',
  vibe: ['Active', 'Casual', 'Budget-friendly'],
  image:
    'https://images.unsplash.com/photo-1682953393270-1dd49c0c4989?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'A low-cost indoor skating outing where teams can get active, laugh together, and do something different without needing a large event budget.',
  bestFor:
    'Budget-conscious teams, casual office outings, winter activities, and groups that want an active indoor option.',
  details:
    'Casper Ice Arena is a strong inexpensive option because public skating is simple, active, and easy to understand. It works best for casual teams that want a fun group activity rather than a formal corporate event. Public skate times can change, so teams should confirm the current schedule before planning.',
  contact: 'https://www.casperwy.gov/explore/casper_ice_arena/index.php',
},
{
  id: 'denver-aqua-golf',
  name: 'Aqua Golf',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['outings'],
  category: 'Active Games',
  price: '$',
  groupSize: '6–40',
  duration: '1–2 hrs',
  setting: 'Outdoor',
  vibe: ['Competitive', 'Casual', 'Budget-friendly'],
  image:
    'https://images.unsplash.com/photo-1554587031-e71bd3a34aa1?q=80&w=1674&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'A low-cost golf outing with a water driving range and miniature golf that gives teams an easy competitive activity without a big event budget.',
  bestFor:
    'Budget-conscious teams, casual office outings, groups that like friendly competition, and teams that want an outdoor option.',
  details:
    'Aqua Golf is a practical Denver option for teams that want activity without needing intense athletic ability. It can work as a quick afternoon outing, a casual department meetup, or a relaxed warm-weather team activity.',
  contact: 'https://www.cityofdenvergolf.com/aqua-golf/',
},
    {
  id: 'casper-food-bank-of-wyoming-volunteer',
  name: 'Food Bank of Wyoming Volunteer Shift',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['outings', 'volunteer'],
  category: 'Volunteer',
  price: '$',
  groupSize: '6–30',
  duration: '1.5–3 hrs',
  setting: 'Indoor',
  vibe: ['Purpose-driven', 'Community', 'Hunger Relief', 'Meaningful'],
  image:
    'https://images.unsplash.com/photo-1461354464878-ad92f492a5a0?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'A hands-on volunteer outing where teams can help support hunger relief through food sorting, packing, or related service projects.',
  bestFor:
    'Teams that want a meaningful, low-cost outing with a service focus and a clear community impact.',
  details:
    'This is one of the strongest Casper-area volunteer options for office teams because it can work well as a structured group service activity. It is a good fit for companies that want team-building without making the outing feel overly recreational.',
  contact: 'https://wyomingfoodbank.org/get-involved/volunteer/',
},
{
  id: 'casper-wyoming-food-for-thought-volunteer',
  name: 'Wyoming Food for Thought Project',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['outings', 'volunteer'],
  category: 'Volunteer',
  price: '$',
  groupSize: '6–25',
  duration: '1.5–3 hrs',
  setting: 'Indoor',
  vibe: ['Service', 'Purpose-driven', 'Hunger Relief', 'Community', 'Youth'],
  image:
    'https://images.unsplash.com/photo-1626386717059-90e48caba29e?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'A community-service outing where teams can support food programs serving children and families in Casper.',
  bestFor:
    'Teams that want a local volunteer opportunity, nonprofit service project, or purpose-driven alternative to a typical outing.',
  details:
    'Wyoming Food for Thought Project is a good fit for groups that want to give back in a practical way. Teams should contact the organization ahead of time to confirm current group volunteer needs and scheduling.',
  contact: 'https://www.wyomingfoodforthoughtproject.org/',
},
{
  id: 'casper-wyoming-rescue-mission-volunteer',
  name: 'Wyoming Rescue Mission Volunteer Project',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['outings', 'volunteer'],
  category: 'Volunteer',
  price: '$',
  groupSize: '6–20',
  duration: '1.5–3 hrs',
  setting: 'Indoor',
  vibe: ['Service', 'Purpose-driven', 'Community', 'Hunger Relief'],
  image:
    'https://images.unsplash.com/photo-1511632765486-a01980e01a18?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'A service-based team outing where groups can support Wyoming Rescue Mission through volunteer projects, event help, or seasonal needs.',
  bestFor:
    'Teams that want a meaningful local service activity, especially around holidays, fundraisers, or community outreach.',
  details:
    'This is a good Casper option for teams that want to help a local mission rather than do a recreational activity. Because volunteer needs may vary by season, teams should contact Wyoming Rescue Mission directly to ask what group projects are currently available.',
  contact: 'https://www.wyomission.org/get-involved/volunteer',
},
  {
    id: 'denver-clyfford-still-self-guided-group',
    name: 'Clyfford Still Museum Group Visit',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '10–20',
    duration: '1–1.5 hrs',
    setting: 'Indoor',
    vibe: ['Creative', 'Relaxed', 'Conversation-friendly'],
    image:
      'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?q=80&w=890&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    summary:
      'A calm, art-focused museum visit that works well for conversation, reflection, and a low-pressure team outing.',
    bestFor:
      'Creative teams, nonprofit teams, smaller offices, client groups, and teams that prefer quiet cultural outings.',
    details:
      'Clyfford Still Museum welcomes self-guided group visits and asks for notice for groups of 10 or more. This is an easy indoor option for teams that want a thoughtful cultural stop.',
    contact: 'https://clyffordstillmuseum.org/plan-your-visit/hours-and-tickets/',
  },
  {
  id: 'denver-training-group-leadership-boot-camp',
  name: 'Denver Training Group Leadership Boot Camp',
  active: true,
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['trainings'],
  category: 'Leadership Training',
  price: '$$$',
  groupSize: '5–100+',
  duration: 'Half or full day',
  setting: 'Indoor / Virtual',
  vibe: [ 'Leadership', 'Communication', 'Team Building', 'Professional Development'],
  image:
    'https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A customized leadership workshop covering communication, emotional intelligence, conflict resolution, resilience, coaching, and high-performing teams.',
  bestFor:
    'Emerging leaders, management teams, supervisors, and organizations building a stronger leadership pipeline.',
  details:
    'Denver Training Group delivers customized leadership workshops at the company’s location, at a rented venue, or through a live webinar. Workshops can be structured as half-day or full-day sessions.',
  contact:
    'https://denvertraininggroup.com/services/denver-leadership-training-programs/',
},

{
  id: 'denver-training-group-disc-workshop',
  name: 'Everything DiSC Team Communication Workshop',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['trainings'],
  category: 'Team Communication',
  price: '$$$',
  groupSize: '5–100+',
  duration: 'Half or full day',
  setting: 'Indoor / Virtual',
  vibe: [
    'Communication',
    'Team Building',
    'Leadership',
    'Professional Development',
  ],
  image:
    'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80',
  summary:
    'An interactive DiSC workshop designed to help coworkers understand communication styles, reduce tension, and collaborate more effectively.',
  bestFor:
    'New teams, cross-functional groups, leadership teams, and coworkers experiencing communication challenges.',
  details:
    'Participants use the Everything DiSC framework to explore their behavioral preferences and understand how those preferences affect teamwork, communication, and leadership.',
  contact:
    'https://denvertraininggroup.com/services/denver-disc-training-programs/',
},

{
  id: 'denver-zoe-training-lunch-and-learn',
  name: 'Zoe Training 90-Minute Lunch and Learn',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['trainings'],
  category: 'Professional Development',
  price: '$$',
  groupSize: '5–100+',
  duration: '90 min',
  setting: 'Indoor / Virtual',
  vibe: [
    'Communication',
    'Leadership',
    'Professional Development',
    'Team Building',
  ],
  image:
    'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A condensed professional-development workshop that gives teams practical skills without requiring a full day away from work.',
  bestFor:
    'Busy teams, employee-development days, manager meetings, and companies introducing a new workplace skill.',
  details:
    'Zoe Training offers customizable Lunch and Learn sessions on topics such as situational communication, leadership, management, and workplace effectiveness.',
  contact:
    'https://www.zoetraining.com/professional-training-courses/90-minute-lunch-and-learn/',
},

{
  id: 'denver-dale-carnegie-corporate-training',
  name: 'Dale Carnegie Corporate Training',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['trainings'],
  category: 'Leadership and Communication',
  price: '$$$',
  groupSize: '5–100+',
  duration: '2 hrs–multi-session',
  setting: 'Indoor / Virtual',
  vibe: [
    'Leadership',
    'Communication',
    'Professional Development',
    'Sales',
  ],
  image:
    'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=80',
  summary:
    'Customized corporate training focused on leadership, communication, collaboration, presentations, customer service, or sales.',
  bestFor:
    'Management teams, sales organizations, customer-facing employees, and companies planning a longer development program.',
  details:
    'Dale Carnegie works with organizations to assess their needs and build customized in-person or live-online training solutions.',
  contact:
    'https://www.dalecarnegie.com/en/franchise-locations/colorado',
},

{
  id: 'denver-core-progression-workplace-wellness',
  name: 'Core Progression Workplace Wellness Program',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['trainings', 'outings'],
  category: 'Workplace Wellness',
  price: '$$',
  groupSize: '5–100+',
  duration: 'Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Workplace Wellness',
    'Team Building',
    'Professional Development',
  ],
  image:
    'https://images.unsplash.com/photo-1603206004639-22635b71ac08?q=80&w=1674&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'A customizable workplace wellness program that can include fitness education, team challenges, onsite sessions, or online training.',
  bestFor:
    'Employee wellness initiatives, active teams, health-focused organizations, and companies planning a wellness week.',
  details:
    'Core Progression can bring trainers onsite, host teams at its facilities, or provide online programming. Programs can be customized for small teams or larger organizations.',
  contact:
    'https://coreprogression.com/corporate-wellness/',
},

{
  id: 'casper-college-custom-workforce-training',
  name: 'Casper College Customized Workforce Training',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['trainings'],
  category: 'Customized Business Training',
  price: '$$',
  groupSize: '5–100+',
  duration: 'Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Leadership',
    'Professional Development',
    'Communication',
    'Team Building',
  ],
  image:
    'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80',
  summary:
    'Customized workforce training developed around an organization’s leadership, business, professional-development, safety, or technical needs.',
  bestFor:
    'Casper employers seeking a local training partner and organizations that need a program tailored to their workforce.',
  details:
    'Casper College works with organizations to assess their needs and develop customized training intended to improve employee skills, productivity, and organizational performance.',
  contact:
    'https://www.caspercollege.edu/programs-courses/continuing-education/businesses/',
},

{
  id: 'casper-nobleprog-workplace-communication',
  name: 'Effective Communication in the Workplace',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['trainings'],
  category: 'Communication Training',
  price: '$$$',
  groupSize: '1–20',
  duration: '14 hrs',
  setting: 'Indoor / Virtual',
  vibe: [
    'Communication',
    'Professional Development',
    'Team Building',
  ],
  image:
    'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=80',
  summary:
    'An instructor-led course focused on improving workplace communication, clarity, active listening, empathy, and professional presentations.',
  bestFor:
    'Teams experiencing communication gaps, supervisors, client-facing employees, and professionals who frequently present ideas.',
  details:
    'This course is available online or onsite in Casper and uses interactive exercises, case studies, and workplace scenarios to strengthen oral and written communication.',
  contact:
    'https://www.nobleprog.com/communication/training/casper',
},

{
  id: 'casper-nobleprog-courageous-conversations',
  name: 'Courageous Conversations for Leaders',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['trainings'],
  category: 'Leadership Training',
  price: '$$$',
  groupSize: '1–20',
  duration: '7 hrs',
  setting: 'Indoor / Virtual',
  vibe: [
    'Leadership',
    'Communication',
    'Professional Development',
  ],
  image:
    'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A leadership workshop centered on direct communication, accountability, expectations, delegation, and constructive performance conversations.',
  bestFor:
    'Managers, directors, supervisors, team leads, and newly promoted leaders.',
  details:
    'NobleProg offers this instructor-led leadership training online or onsite in Casper. The program emphasizes practical communication and accountability skills for workplace leaders.',
  contact:
    'https://www.nobleprog.com/corporate-leadership/training/casper',
},
  {
  id: 'denver-david-suson-keynote',
  name: 'David Suson Leadership Keynote',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['speakers'],
  category: 'Leadership Speaker',
  price: '$$$',
  groupSize: '25–500+',
  duration: '45–90 min / Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Leadership',
    'Communication',
    'Motivation',
    'Workplace Culture',
  ],
  image:
    'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A leadership keynote focused on improving trust, communication, human connection, accountability, and team performance.',
  bestFor:
    'Leadership conferences, executive retreats, sales kickoffs, managers, associations, and customer-facing teams.',
  details:
    'David Suson offers customized in-person, virtual, and hybrid keynotes, workshops, leadership programs, and half-day or full-day sessions.',
  contact:
    'https://davidsuson.com/',
},
{
  id: 'denver-brad-montgomery',
  name: 'Brad Montgomery',
  preferred: true,
  active: true,
  partnerPageUrl: 'https://bradmontgomery.teamward.ai/',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['speakers'],
  category: 'Speaker / Emcee / Entertainment',
  price: 'From $10,000',
  groupSize: '5–5,000',
  duration: 'Up to 90 min / Full day',
  setting: 'In-person / Virtual',
  vibe: [
    'Keynotes',
    'Leadership',
    'Audience Engagement',
    'Corporate Entertainment',
  ],
 image: bradMontgomeryImage,
imagePosition: 'center top',
  heroTextWidth: '700px',
  summary:
    'Keynotes, emcee services, and virtual programs for corporate groups of 5 to 5,000.',
  bestFor:
    'Corporate conferences, leadership meetings, executive retreats, association events, employee celebrations, and programs that need both energy and audience engagement.',
  details:
    'Brad brings decades of live-stage experience to business events, from five-person C-suite sessions to conference audiences of 5,000. Organizations can book him for a keynote, an expanded keynote with a breakout, emcee services, or a virtual presentation.',
  programs: [
    {
      name: 'Keynote',
      price: '$15,000 + travel',
      note: 'Up to 90 minutes',
    },
    {
      name: 'Keynote + Breakout',
      price: '$22,500 + travel',
      note: 'Expanded program',
    },
    {
      name: 'Emcee / Host',
      price: '$15,000 per day',
      note: 'Including rehearsal days',
    },
    {
      name: 'Virtual Program',
      price: '$15,000',
      note: 'Lower-cost virtual formats may be available',
    },
    {
      name: 'Mentalism Comedy Show',
      price: '$10,000 + travel',
      note: 'Interactive corporate entertainment',
    },
  ],
  planningNotes:
    'Brad travels from Denver. Airfare, ground transportation, and hotel are additional where noted. He may consider adjusted pricing for local or driveable events and select opportunities. Teamward can help determine the best format and coordinate any offer below the listed fee before connecting you directly with Brad’s team.',
  contact: 'mailto:mkuhl@teamward.ai',
},
{
  id: 'denver-kari-knutson-keynote',
  name: 'Kari Knutson Communication Keynote',
  active: false,
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['speakers'],
  category: 'Communication Speaker',
  price: '$$$',
  groupSize: '20–500+',
  duration: 'Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Communication',
    'Leadership',
    'Workplace Culture',
    'Motivation',
  ],
  image:
    'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80',
  summary:
    'An engaging keynote centered on emotional intelligence, communication, meaningful connection, personal growth, and stronger teams.',
  bestFor:
    'Professional-development events, leadership teams, conferences, employee gatherings, and organizations working on team connection.',
  details:
    'Kari Knutson offers keynote presentations, breakout sessions, workshops, coaching, and a storytelling-based one-woman show for events.',
  contact:
    'https://knutsonspeaks.com/',
},

{
  id: 'denver-daniela-paz-transformation-keynote',
  name: 'Daniela Paz Transformation Keynote',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['speakers'],
  category: 'Motivational Speaker',
  price: '$$$',
  groupSize: '25–500+',
  duration: '30–90 min',
  setting: 'Indoor / Virtual',
  vibe: [
    'Motivation',
    'Leadership',
    'Wellness',
    'Workplace Culture',
  ],
  image:
    'https://images.unsplash.com/photo-1602137933752-921eab594fd5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'A transformational keynote helping audiences overcome internal barriers, strengthen resilience, navigate change, and take intentional action.',
  bestFor:
    'Corporate conferences, leadership retreats, annual kickoffs, wellness events, off-sites, and virtual team gatherings.',
  details:
    'Daniela Paz offers customized keynotes on resilience, transformation, self-leadership, change, limiting beliefs, clarity, and personal accountability.',
  contact:
    'https://www.danielapazspeaker.com/',
},

{
  id: 'denver-richard-bryan-leadership-keynote',
  name: 'Richard J. Bryan Leadership Keynote',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['speakers'],
  category: 'Business Growth Speaker',
  price: '$$$',
  groupSize: '25–500+',
  duration: 'Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Leadership',
    'Motivation',
    'Workplace Culture',
  ],
  image:
    'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A business-focused keynote combining leadership lessons, organizational growth strategies, team development, and executive experience.',
  bestFor:
    'Business owners, senior executives, management teams, leadership conferences, and organizations working toward sustainable growth.',
  details:
    'Richard J. Bryan speaks on strategic leadership, business growth, leadership development, delegation, culture, and building stronger management teams.',
  contact:
    'https://richardjbryan.com/speaking/',
},

{
  id: 'denver-voicequest-speaker-matching',
  name: 'VoiceQuest Speaker Matching',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['speakers'],
  category: 'Speaker Matching Service',
  price: '$$$',
  groupSize: '25–500+',
  duration: 'Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Leadership',
    'Communication',
    'Motivation',
    'Workplace Culture',
    'Wellness',
    'Innovation',
  ],
  image:
    'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A Denver-based speaker agency that helps organizations identify and book a speaker aligned with their audience, budget, goals, and desired outcomes.',
  bestFor:
    'Companies that want help comparing keynote speakers instead of researching and contacting individual speakers themselves.',
  details:
    'VoiceQuest can source keynote speakers, breakout presenters, moderators, facilitators, and panelists covering leadership, culture, resilience, communication, innovation, AI, engagement, and wellness.',
  contact:
    'https://www.voicequestagency.com/',
},

{
  id: 'casper-dallin-cooper-keynote',
  name: 'Dallin Cooper Communication Keynote',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['speakers'],
  category: 'Communication and Leadership Speaker',
  price: '$$$',
  groupSize: '25–500+',
  duration: 'Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Communication',
    'Leadership',
    'Motivation',
    'Workplace Culture',
    'Wellness',
  ],
  image:
    'https://images.unsplash.com/photo-1544531586-fde5298cdd40?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'An energetic keynote using humor and practical tools to help teams handle disagreement, build trust, improve communication, and balance grit with burnout.',
  bestFor:
    'Leadership conferences, annual meetings, company retreats, sales events, professional-development days, and high-performing teams.',
  details:
    'Dallin Cooper offers programs on workplace conflict, communication, trust, leadership, teamwork, mental wellness, resilience, and burnout.',
  contact:
    'https://dallincooper.com/',
},

{
  id: 'casper-wyoming-speakers-network',
  name: 'Wyoming Speakers Network Matching Service',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['speakers'],
  category: 'Speaker Matching Service',
  price: '$$$',
  groupSize: '25–500+',
  duration: 'Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Leadership',
    'Communication',
    'Motivation',
    'Workplace Culture',
    'Wellness',
  ],
  image:
    'https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A regional speaker-matching service that helps Wyoming organizations locate keynote speakers, trainers, motivational speakers, and workshop leaders.',
  bestFor:
    'Casper organizations that need multiple speaker options or help locating a speaker for a specialized topic.',
  details:
    'The network matches events with speakers covering leadership, sales, customer service, team building, employee morale, work-life balance, change, performance, and other workplace topics.',
  contact:
    'https://www.wyomingspeakersnetwork.com/request-a-speaker/',
},
  {
  id: 'denver-botanic-gardens-corporate-retreat',
  name: 'Denver Botanic Gardens Corporate Retreat',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['retreats'],
  category: 'Botanical Retreat Venue',
  price: '$$$',
  groupSize: '10–250+',
  duration: 'Half or full day',
  setting: 'Indoor / Outdoor',
  vibe: [
    'Strategic Planning',
    'Wellness',
    'Celebration',
    'Rest and Recharge',
  ],
  image:
    'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A garden-based retreat setting with indoor and outdoor spaces for strategy sessions, meetings, celebrations, and restorative team time.',
  bestFor:
    'Leadership teams, nonprofit boards, planning retreats, employee appreciation events, and teams wanting a calm natural environment.',
  details:
    'Denver Botanic Gardens at York Street hosts corporate retreats and meetings across a 24-acre campus with eight outdoor rental spaces and four indoor spaces.',
  contact:
    'https://www.botanicgardens.org/private-events',
},

{
  id: 'denver-clock-tower-board-retreat',
  name: 'Denver Clock Tower Board Retreat',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['retreats'],
  category: 'Downtown Retreat Venue',
  price: '$$$',
  groupSize: '8–46',
  duration: '3–8 hrs',
  setting: 'Indoor',
  vibe: [
    'Strategic Planning',
    'Leadership Development',
    'Team Bonding',
    'Celebration',
  ],
  image:
    'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A private downtown retreat space spanning five distinctive floors with skyline views, balconies, lounge areas, and presentation configurations.',
  bestFor:
    'Board retreats, executive planning sessions, leadership gatherings, brainstorming days, and milestone celebrations.',
  details:
    'The historic Daniels and Fisher Clock Tower supports corporate retreats, presentations, team building, brainstorming sessions, and board retreats.',
  contact:
    'https://www.denverclocktower.com/',
},

{
  id: 'denver-crawford-hotel-executive-retreat',
  name: 'The Crawford Hotel Executive Retreat',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['retreats'],
  category: 'Executive Board Retreat',
  price: '$$$',
  groupSize: '4–20',
  duration: '2–8 hrs',
  setting: 'Indoor',
  vibe: [
    'Strategic Planning',
    'Leadership Development',
    'Celebration',
  ],
  image:
    'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A polished executive retreat inside Denver Union Station with a private boardroom, integrated presentation technology, and nearby hotel accommodations.',
  bestFor:
    'Executive teams, board members, strategic planning sessions, leadership discussions, and confidential company meetings.',
  details:
    'The Belz Boardroom accommodates four to twenty guests and includes a custom boardroom table, high-speed Wi-Fi, audiovisual equipment, a large monitor, and wireless presentation technology.',
  contact:
    'https://www.thecrawfordhotel.com/gather/venues/belz-boardroom/',
},

{
  id: 'casper-hogadon-basin-lodge-retreat',
  name: 'Hogadon Basin Lodge Mountain Retreat',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['retreats'],
  category: 'Mountain Retreat Venue',
  price: '$$$',
  groupSize: '10–150',
  duration: 'Half or full day',
  setting: 'Indoor / Outdoor',
  vibe: [
    'Strategic Planning',
    'Team Bonding',
    'Celebration',
    'Rest and Recharge',
  ],
  image:
    'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A secluded mountaintop retreat venue with panoramic views, flexible meeting layouts, indoor lodge space, patios, catering, and optional event enhancements.',
  bestFor:
    'Staff retreats, board retreats, strategy days, team celebrations, leadership meetings, and groups wanting a mountain setting near Casper.',
  details:
    'Hogadon Basin Lodge supports staff and board retreats, corporate meetings, private dinners, and celebrations. Meeting layouts can accommodate up to 150 guests.',
  contact:
    'https://hogadonlodge.com/',
},

{
  id: 'casper-trout-on-inn-corporate-retreat',
  name: 'Trout On Inn Riverside Retreat',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['retreats', 'outings'],
  category: 'Riverside Retreat',
  price: '$$$',
  groupSize: '6–40',
  duration: '1–3 days',
  setting: 'Indoor / Outdoor',
  vibe: [
    'Team Bonding',
    'Wellness',
    'Rest and Recharge',
    'Celebration',
  ],
  image:
    'https://images.unsplash.com/photo-1604951832436-90867d74f4de?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'A riverside Wyoming retreat combining cabins, outdoor gathering space, guided fishing, recreation, and time away from the office.',
  bestFor:
    'Small company retreats, leadership teams, reward trips, team-bonding weekends, and groups interested in fishing or outdoor relaxation.',
  details:
    'Trout On Inn is located on the North Platte River and offers lodging, guided fishing trips, riverside cabins, corporate events, retreats, and onsite activities.',
  contact:
    'https://troutoninn.com/',
},

{
  id: 'casper-ramkota-hotel-company-retreat',
  name: 'Ramkota Hotel Company Retreat',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['retreats'],
  category: 'Full-Service Retreat Hotel',
  price: '$$$',
  groupSize: '10–500+',
  duration: '1–3 days',
  setting: 'Indoor',
  vibe: [
    'Strategic Planning',
    'Leadership Development',
    'Team Bonding',
    'Celebration',
  ],
  image:
    'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A full-service hotel retreat with guest rooms, meeting spaces, catering, presentation technology, dining, and room-block convenience.',
  bestFor:
    'Multi-day company retreats, conferences, management meetings, leadership development events, and larger team gatherings.',
  details:
    'Ramkota Casper offers approximately 14,000 square feet of flexible meeting and banquet space, onsite catering, audiovisual equipment, guestrooms, dining, and professional meeting support.',
  contact:
    'https://www.ramkotacasper.com/groups-meetings',
},

{
  id: 'casper-events-at-the-m-retreat',
  name: 'Events at The M Team Retreat',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['retreats'],
  category: 'Downtown Retreat Venue',
  price: '$$$',
  groupSize: '10–380',
  duration: 'Half or full day',
  setting: 'Indoor / Outdoor',
  vibe: [
    'Strategic Planning',
    'Team Bonding',
    'Leadership Development',
    'Celebration',
  ],
  image:
    'https://images.unsplash.com/photo-1527529482837-4698179dc6ce?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  summary:
    'A flexible downtown retreat venue with conference rooms, a large rotunda, outdoor patio, stage, projector, microphones, and coordinated event support.',
  bestFor:
    'Company-wide retreats, planning sessions, workshops, employee celebrations, presentations, and larger leadership gatherings.',
  details:
    'Events at The M includes two conference rooms and a rotunda accommodating up to 380 guests, along with an outdoor patio, staging, projection, microphones, speakers, and an event coordinator.',
  contact:
    'https://www.eventsatthem.com/',
},
  {
  id: 'denver-employers-council-leading-teams',
  name: 'Employers Council Leading Teams',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['trainings'],
  category: 'Leadership and Team Development',
  price: '$$',
  groupSize: '1–100+',
  duration: 'Instructor-led',
  setting: 'Indoor / Virtual',
  vibe: [
    'Leadership',
    'Team Building',
    'Communication',
    'Professional Development',
  ],
  image:
    'https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1200&q=80',
  summary:
    'Instructor-led team development focused on the behaviors, communication, trust, and accountability that help teams perform well.',
  bestFor:
    'Managers, supervisors, newly formed teams, cross-functional groups, and organizations working to improve team performance.',
  details:
    'Employers Council offers Leading Teams as part of its training catalog, with virtual training and in-person classes available through its Denver office. Pricing and session availability should be confirmed before booking.',
  contact:
    'https://members.employerscouncil.org/training-development/training',
},
{
  id: 'denver-employers-council-communication-style',
  name: 'Employers Council Communication Skills: Discover Your Style',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['trainings'],
  category: 'Communication Training',
  price: '$$',
  groupSize: '1–100+',
  duration: 'Instructor-led',
  setting: 'Indoor / Virtual',
  vibe: [
    'Communication',
    'Team Building',
    'Professional Development',
  ],
  image:
    'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A practical communication course that helps participants understand their communication styles and work more effectively with others.',
  bestFor:
    'Cross-functional teams, client-facing employees, new teams, managers, and coworkers experiencing communication friction.',
  details:
    'Participants examine communication styles, speaker and listener roles, intentions, and verbal and nonverbal cues. Confirm current virtual and in-person pricing before booking.',
  contact:
    'https://training.employerscouncil.org/learn/courses/48/communication-skills-101',
},
{
  id: 'denver-employers-council-workplace-eq',
  name: 'Employers Council Building Workplace EQ',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['trainings'],
  category: 'Workplace Wellness',
  price: '$$',
  groupSize: '1–100+',
  duration: 'Instructor-led',
  setting: 'Indoor / Virtual',
  vibe: [
    'Workplace Wellness',
    'Communication',
    'Leadership',
    'Professional Development',
  ],
  image:
    'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=1200&q=80',
  summary:
    'Emotional-intelligence training designed to strengthen self-awareness, communication, empathy, and workplace interactions.',
  bestFor:
    'Managers, emerging leaders, high-stress teams, customer-facing employees, and organizations focused on healthier workplace communication.',
  details:
    'Building Workplace EQ focuses on emotional intelligence and more effective workplace interactions. Confirm the available format, pricing, and dates directly with the provider.',
  contact:
    'https://www.employerscouncil.org/employee-training-development/',
},
{
  id: 'denver-wellpower-mental-health-first-aid',
  name: 'WellPower Mental Health First Aid for Workplaces',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['trainings'],
  category: 'Workplace Wellness',
  price: '$$',
  groupSize: '5–30',
  duration: 'Private class',
  setting: 'Indoor / Virtual',
  vibe: [
    'Workplace Wellness',
    'Communication',
    'Professional Development',
  ],
  image:
    'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A private workplace class that helps employees build mental-health knowledge and learn practical ways to respond and connect people with support.',
  bestFor:
    'HR teams, managers, supervisors, people leaders, employee-resource groups, and organizations prioritizing workplace mental health.',
  details:
    'WellPower offers private Mental Health First Aid classes for workplaces and groups, either in person or online. Request current pricing and allow time for scheduling.',
  contact:
    'https://www.wellpower.org/mental-health-first-aid/',
},
{
  id: 'casper-college-building-teams-that-work',
  name: 'Casper College Building Teams That Work',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['trainings'],
  category: 'Team Building Training',
  price: '$',
  groupSize: '1–100+',
  duration: '12 lessons',
  setting: 'Virtual',
  vibe: [
    'Team Building',
    'Communication',
    'Leadership',
    'Professional Development',
  ],
  image:
    'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=1200&q=80',
  summary:
    'An affordable online course covering team development, collaboration, and approaches for handling interpersonal conflict.',
  bestFor:
    'Small businesses, supervisors, new teams, employees moving into leadership, and budget-conscious organizations.',
  details:
    'Casper College Workforce Development offers Building Teams That Work as an online business and professional-development course. Confirm current enrollment details and pricing before booking.',
  contact:
    'https://www.caspercollege.edu/news/2024/10/ccs-workforce-development-offers-online-business-and-professional-development-classes/',
},
{
  id: 'casper-skillpath-psychological-safety',
  name: 'SkillPath Creating a Psychologically Safe Workplace',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['trainings'],
  category: 'Workplace Wellness',
  price: '$',
  groupSize: '1–100+',
  duration: '1 hr',
  setting: 'Virtual',
  vibe: [
    'Workplace Wellness',
    'Team Building',
    'Communication',
    'Professional Development',
  ],
  image:
    'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A live virtual workshop available to Casper teams that focuses on creating a workplace where employees feel safe speaking up, contributing, and collaborating.',
  bestFor:
    'Managers, HR teams, supervisors, newly formed teams, and organizations working to improve trust and employee participation.',
  details:
    'SkillPath offers this as a live virtual workshop and provides private group-training options. Confirm current dates and pricing before booking.',
  contact:
    'https://skillpath.com/virtual/creating-a-psychologically-safe-workplace',
},
  {
  id: 'denver-heather-younger-workplace-culture',
  name: 'Heather R. Younger Workplace Culture Keynote',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['speakers'],
  category: 'Workplace Culture Speaker',
  price: '$$$',
  groupSize: '25–500+',
  duration: 'Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Leadership',
    'Workplace Culture',
    'Communication',
    'Wellness',
  ],
  image:
    'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A workplace-culture keynote focused on resilient leadership, trust, employee engagement, communication, and sustaining strong teams under pressure.',
  bestFor:
    'Leadership conferences, HR events, employee gatherings, management retreats, and organizations navigating change or burnout.',
  details:
    'Heather R. Younger offers interactive in-person and virtual keynotes designed to help leaders build trust, strengthen workplace culture, navigate pressure, and create teams that stay engaged during change.',
  contact:
    'https://heatheryounger.com/speaking/',
},
{
  id: 'denver-susan-frew-ai-keynote',
  name: 'Susan Frew AI and Innovation Keynote',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['speakers'],
  category: 'AI and Innovation Speaker',
  price: '$$$',
  groupSize: '25–500+',
  duration: 'Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Innovation',
    'Leadership',
    'Communication',
    'Workplace Culture',
  ],
  image:
    'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A practical AI keynote that helps business audiences understand artificial intelligence, identify useful applications, and approach innovation with greater confidence.',
  bestFor:
    'Company conferences, leadership meetings, business associations, executive teams, entrepreneurs, and organizations beginning to adopt AI.',
  details:
    'Susan Frew combines corporate leadership, entrepreneurship, and hands-on AI experience to make artificial intelligence understandable and useful for nontechnical business audiences. Topics include AI implementation, efficiency, ethics, innovation, and leadership in the age of automation.',
  contact:
    'https://www.susanfrewspeaks.com/speaking',
},
{
  id: 'denver-kenyon-salo-motivational-keynote',
  name: 'Kenyon Salo Motivational Keynote',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['speakers'],
  category: 'Motivational Speaker',
  price: '$$$',
  groupSize: '25–500+',
  duration: 'Custom',
  setting: 'Indoor',
  vibe: [
    'Motivation',
    'Leadership',
    'Workplace Culture',
  ],
  image:
    'https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A high-energy motivational keynote combining adventure, humor, storytelling, and practical encouragement to help people take action on meaningful goals.',
  bestFor:
    'Sales kickoffs, annual meetings, employee-appreciation events, leadership conferences, and teams that need renewed energy and motivation.',
  details:
    'Kenyon Salo speaks on motivation, inspiration, leadership, adventure, sales, and customer service. His presentations use stories from skydiving and adventure to encourage audiences to take action, create memorable experiences, and approach work and life with greater purpose.',
  contact:
    'https://kenyonsalo.com/speaking/',
},
  {
  id: 'casper-charles-marshall-motivational-keynote',
  name: 'Charles Marshall Humorous Motivational Keynote',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['speakers'],
  category: 'Motivational Speaker',
  price: '$$$',
  groupSize: '25–500+',
  duration: 'Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Motivation',
    'Leadership',
    'Workplace Culture',
    'Communication',
  ],
  image:
    'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80',
  summary:
    'An upbeat motivational keynote combining clean humor, personal-development lessons, leadership encouragement, and practical ideas for improving morale.',
  bestFor:
    'Company meetings, management conferences, employee-appreciation events, association gatherings, and teams that want motivation without a dry presentation.',
  details:
    'Charles Marshall delivers humorous motivational presentations designed to increase energy, morale, productivity, and personal accountability. He has presented in Casper and throughout Wyoming and also offers virtual keynote programs.',
  contact:
    'https://charlesmarshall.net/wyoming-funny-motivational-keynote-speaker/',
},
{
  id: 'casper-larry-weaver-wellness-keynote',
  name: 'Larry Weaver Motivation and Wellness Keynote',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['speakers'],
  category: 'Wellness and Motivational Speaker',
  price: '$$$',
  groupSize: '25–500+',
  duration: 'Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Motivation',
    'Wellness',
    'Leadership',
    'Workplace Culture',
  ],
  image:
    'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A clean, humorous keynote focused on positive attitude, resilience, stress management, wellness, change, and staying motivated at work.',
  bestFor:
    'Employee meetings, wellness events, conferences, staff-development days, company celebrations, and teams working through stress or change.',
  details:
    'Larry Weaver combines motivational insights, clean comedy, and practical lessons on resilience, workplace attitude, stress reduction, teamwork, and wellness. He is available for Casper and other Wyoming events as well as virtual presentations.',
  contact:
    'https://www.larryweaver.com/state/wyoming/',
},
  {
  id: 'denver-parks-trash-bash',
  name: 'Denver Parks Trash Bash',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['outings', 'volunteer'],
  category: 'Environmental Volunteer Event',
  price: '$',
  groupSize: '5–25',
  duration: '2 hrs',
  setting: 'Outdoor',
  vibe: [
    'Purpose-driven',
    'Community',
    'Environment',
    'Outdoor',
    'Community impact',
  ],
  image:
    'https://images.unsplash.com/photo-1559027615-cd4628902d4a?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A low-cost outdoor volunteer outing where teams help remove litter and improve one of Denver’s public parks.',
  bestFor:
    'Small and mid-size teams, sustainability committees, employee volunteer groups, and companies looking for an approachable outdoor service project.',
  details:
    'Denver Parks and Recreation hosts recurring Trash Bash events at parks throughout the city. Staff provide the project tools and supplies, while participants should bring water, closed-toe shoes, and weather-appropriate clothing. Available space varies by event, so teams should register early.',
  contact:
    'https://engagedenver.denvergov.org/D/Parks/CalendarList',
},
{
  id: 'denver-adopt-an-open-space',
  name: 'Denver Adopt an Open Space Volunteer Project',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['outings', 'volunteer'],
  category: 'Environmental Volunteer Event',
  price: '$',
  groupSize: '5–30',
  duration: '2–3 hrs / Ongoing',
  setting: 'Outdoor',
  vibe: [
    'Purpose-driven',
    'Community',
    'Environment',
    'Outdoor',
    'Community impact',
  ],
  image:
    'https://images.unsplash.com/photo-1593113598332-cd288d649433?auto=format&fit=crop&w=1200&q=80',
  summary:
    'An outdoor stewardship opportunity where teams can help restore and maintain Denver’s urban open spaces.',
  bestFor:
    'Companies seeking an ongoing volunteer relationship, sustainability-focused teams, active groups, and departments that want visible community impact.',
  details:
    'Denver Adopt an Open Space volunteers may assist with litter cleanup, invasive-species removal, ecological restoration, and other stewardship work. Some projects are self-directed while others are supervised by Denver Parks and Recreation. Teams should apply or inquire before selecting a date.',
  contact:
    'https://engagedenver.denvergov.org/GetInvolved/VolunteerGroup/6c249650-6eda-4450-97df-795c37a959c9',
},
  {
  id: 'denver-project-helping-virtual-kynd-kits',
  name: 'Project Helping Virtual Kynd Kit Event',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['outings', 'volunteer'],
  category: 'Virtual Volunteer Event',
  price: '$$',
  groupSize: '5–500+',
  duration: '60–90 min / Custom',
  setting: 'Indoor / Virtual',
  vibe: [
    'Purpose-driven',
    'Community',
    'Wellness',
    'Remote-friendly',
    'Community impact',
  ],
  image:
    'https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A virtual volunteer event where employees receive all the materials needed to complete a meaningful service project from home.',
  bestFor:
    'Remote teams, hybrid companies, distributed departments, employee-resource groups, and organizations that need an inclusive volunteer option.',
  details:
    'Project Helping ships Kynd Kits directly to participants and can provide a hosted virtual build session. Companies can choose from numerous cause areas and combine shipped kits with an in-office or community volunteer event for hybrid teams.',
  contact:
    'https://projecthelping.org/corporate-volunteering-menu/',
},
  {
  id: 'denver-dry-clean-only-corporate-retreat',
  name: 'Dry Clean Only Corporate Retreat',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['retreats'],
  category: 'Creative Retreat Venue',
  price: '$$$',
  groupSize: '10–300',
  duration: '5–10 hrs',
  setting: 'Indoor / Outdoor',
  vibe: [
    'Strategic Planning',
    'Team Bonding',
    'Celebration',
    'Creative',
  ],
  image:
    'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A flexible, light-filled Denver event space that can be customized for company retreats, seminars, workshops, team activities, and celebrations.',
  bestFor:
    'Company-wide retreats, creative teams, workshops, employee celebrations, planning sessions, and larger groups that want a customizable space.',
  details:
    'Dry Clean Only offers an open indoor event space, adjoining patio, included furniture, Wi-Fi, flexible five- and ten-hour rental options, beverage service, and freedom to bring in licensed caterers. Confirm current pricing and availability directly with the venue.',
  contact:
    'https://www.dcodenver.com/corporateevents',
},
  {
  id: 'denver-cable-center-hybrid-retreat',
  name: 'The Cable Center Hybrid Executive Retreat',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['retreats'],
  category: 'Hybrid Executive Retreat',
  price: '$$$',
  groupSize: '15–50',
  duration: 'Half or full day',
  setting: 'Indoor / Virtual',
  vibe: [
    'Strategic Planning',
    'Leadership Development',
    'Team Bonding',
    'Innovation',
  ],
  image:
    'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A professional Denver retreat setting with executive meeting space and technology for teams combining in-person and remote participants.',
  bestFor:
    'Executive retreats, board meetings, leadership teams, hybrid planning sessions, presentations, and strategic off-sites.',
  details:
    'The Cable Center’s Bresnan Board Room is designed for off-site meetings and corporate retreats. It includes flexible meeting layouts, an outdoor balcony, video conferencing, high-speed Wi-Fi, presentation technology, and optional catering packages.',
  contact:
    'https://cablecenterevents.org/spaces/bresnan-boardroom/',
},
  {
  id: 'denver-teambonding-virtual-corporate-retreat',
  name: 'TeamBonding Virtual Corporate Retreat',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['retreats'],
  category: 'Facilitated Virtual Retreat',
  price: '$$$',
  groupSize: '10–500+',
  duration: 'Custom',
  setting: 'Virtual',
  vibe: [
    'Strategic Planning',
    'Team Bonding',
    'Leadership Development',
    'Rest and Recharge',
  ],
  image:
    'https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A professionally facilitated virtual retreat customized around team connection, strategic planning, communication, mindfulness, or leadership goals.',
  bestFor:
    'Remote teams, hybrid organizations, distributed leadership groups, virtual planning retreats, and companies that cannot bring everyone to one location.',
  details:
    'TeamBonding designs customized virtual retreats that can combine facilitated discussions, strategic-planning time, team activities, games, mindfulness, and connection. Retreats include advance logistics, program design, professional facilitation, and necessary program materials.',
  contact:
    'https://www.teambonding.com/corporate-retreats/',
},
  {
  id: 'casper-rotary-park-bridle-trail-hike',
  name: 'Rotary Park & Bridle Trail Team Hike',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['outings'],
  category: 'Hiking',
  price: '$',
  groupSize: '6–30',
  duration: '1.5–3 hrs',
  setting: 'Outdoor',
  vibe: [
    'Active',
    'Scenic',
    'Team Bonding',
    'Memorable',
  ],
  image:
    'https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A scenic Casper Mountain outing combining Garden Creek Falls, an optional team hike, and a casual picnic in Rotary Park.',
  bestFor:
    'Active teams, visiting employees, wellness outings, small departments, and groups that want a distinctly Casper outdoor experience.',
  details:
    'Teams can take the short walk to Garden Creek Falls or continue onto the longer Bridle Trail for a more active outing. The park also supports picnicking and seasonal outdoor recreation. Groups should choose a route appropriate for participants and check weather and trail conditions before leaving.',
  contact:
    'https://www.visitcasper.com/things-to-do/outdoor-recreation/hiking-trails/rotary-park/',
},
{
  id: 'casper-platte-river-trails-team-ride',
  name: 'Platte River Trails Team Walk or Bike Ride',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['outings'],
  category: 'Walking & Biking',
  price: '$',
  groupSize: '6–50',
  duration: '1–3 hrs',
  setting: 'Outdoor',
  vibe: [
    'Active',
    'Scenic',
    'Flexible',
    'Conversation-friendly',
  ],
  image:
    'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A flexible riverside outing where teams can walk, run, or bike together on Casper’s community trail system.',
  bestFor:
    'Wellness challenges, active teams, casual department outings, mixed-ability groups, and companies looking for an inexpensive outdoor activity.',
  details:
    'The Platte River Trail follows the North Platte River through Casper and offers multiple starting points and route lengths. Teams can organize a short walking meeting, a casual bike ride, or a longer wellness challenge and finish with a picnic at one of the trail’s gathering areas.',
  contact:
    'https://www.platterivertrails.com/',
},
  {
  id: 'denver-washington-park-team-walk-picnic',
  name: 'Washington Park Team Walk & Picnic',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['outings'],
  category: 'Park & Picnic',
  price: '$',
  groupSize: '6–50',
  duration: '1.5–3 hrs',
  setting: 'Outdoor',
  vibe: [
    'Relaxed',
    'Social',
    'Scenic',
    'Low pressure',
  ],
  image:
    'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A relaxed team outing combining a walk around one of Denver’s favorite parks with a casual picnic or coffee afterward.',
  bestFor:
    'Budget-conscious teams, employee appreciation outings, mixed-age groups, wellness-focused teams, and coworkers who want easy conversation.',
  details:
    'Washington Park has two lakes, flower gardens, tree-lined paths, and large grassy areas. Teams can create a simple itinerary with a group walk, optional conversation prompts, lawn games, and a bring-your-own picnic. Check current park rules before organizing a large or structured event.',
  contact:
    'https://www.denver.org/visitdenver_com/about-denver/neighborhood-guides/washington-park/',
},
{
  id: 'denver-cherry-creek-trail-team-walk',
  name: 'Cherry Creek Trail Team Walk',
  city: 'Denver',
  state: 'CO',
  primaryCategories: ['outings'],
  category: 'Walking Trail',
  price: '$',
  groupSize: '4–40',
  duration: '1–3 hrs',
  setting: 'Outdoor',
  vibe: [
    'Relaxed',
    'Active',
    'Conversation-friendly',
    'Flexible',
  ],
  image:
    'https://images.unsplash.com/photo-1472396961693-142e6e269027?auto=format&fit=crop&w=1200&q=80',
  summary:
    'A flexible, low-cost team walk along a paved Denver trail that can be adjusted to fit the group’s schedule and activity level.',
  bestFor:
    'Small and mid-size teams, walking meetings, wellness outings, visiting employees, and groups that want movement without an intense activity.',
  details:
    'The Cherry Creek Trail connects downtown Denver with the Cherry Creek area and offers a mostly flat route used by walkers, runners, and cyclists. Teams can choose a short out-and-back walk or a longer route and finish with coffee, lunch, or drinks nearby.',
  contact:
    'https://www.denver.org/things-to-do/sports-recreation/b-cycle-rides/',
},
  {
    id: 'denver-water-world-group-gathering',
    name: 'Water World Group Gathering',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Outdoor',
    price: '$$',
    groupSize: '50–1000+',
    duration: 'Full day',
    setting: 'Outdoor',
    vibe: ['Active', 'Summer', 'Large group', 'Celebration'],
    image: categoryImages.outdoorEvent,
    summary:
      'A full-day summer outing with published large-group ticket tiers for teams of 50, 100, 200, or more.',
    bestFor:
      'Company picnics, employee-appreciation days, family-inclusive events, and large teams that want an easy all-day activity.',
    details:
      'Water World publishes discounted group tickets for 15 to 150+ guests, with its strongest pricing tiers beginning at 50. Catering and pavilion rentals can be added separately.',
    contact:
      'https://www.waterworldcolorado.com/groups/group-events/group-gatherings/',
  },
  {
    id: 'denver-elitch-gardens-group-outing',
    name: 'Elitch Gardens Group Outing',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Entertainment',
    price: '$$',
    groupSize: '50–15000+',
    duration: 'Half or full day',
    setting: 'Outdoor',
    vibe: ['High energy', 'Large group', 'Celebration', 'Flexible'],
    image: categoryImages.activeGames,
    summary:
      'A scalable amusement-park outing with group admission, optional meal vouchers, and catered-event options for very large teams.',
    bestFor:
      'Company celebrations, summer parties, family-inclusive events, and organizations planning for 100 to 200 or more attendees.',
    details:
      'Elitch Gardens publishes a starting group-ticket price for 50+ guests and also offers catered large-group events. Final pricing depends on date, attendance, and selected add-ons.',
    contact: 'https://elitchgardens.com/small-groups/',
  },
  {
    id: 'denver-wings-over-rockies-group-visit',
    name: 'Wings Over the Rockies Group Visit',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$',
    groupSize: '25+',
    duration: '1.5–3 hrs',
    setting: 'Indoor',
    vibe: ['Educational', 'Local', 'Conversation-friendly', 'Large group'],
    image: categoryImages.museum,
    summary:
      'A budget-friendly aviation museum visit with a published unguided group rate for companies bringing 25 or more people.',
    bestFor:
      'Engineering teams, visiting employees, multigenerational groups, and large teams that want a structured but flexible cultural outing.',
    details:
      'Companies can use the 25+ unguided group admission option. Guided tours are also available, but each guided format has its own smaller capacity limit.',
    contact: 'https://wingsmuseum.org/education/groups-and-tours/',
  },
  {
    id: 'denver-downtown-aquarium-group-visit',
    name: 'Downtown Aquarium Group Visit',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Culture',
    price: '$$',
    groupSize: '10–200',
    duration: '2–4 hrs',
    setting: 'Indoor',
    vibe: ['Social', 'Educational', 'Weather-proof', 'Large group'],
    image: categoryImages.museum,
    summary:
      'An indoor aquarium outing that can handle a large company group through timed admission and optional dining or event-space add-ons.',
    bestFor:
      'Mixed-age teams, winter outings, client events, and groups that want an easy indoor option for 100 to 200 people.',
    details:
      'The aquarium publishes general-admission prices and supports group visits. Very large groups may need staggered entry times; dining and private-event space are separate.',
    contact:
      'https://www.aquariumrestaurants.com/downtownaquariumdenver/exhibits.asp',
  },
  {
    id: 'denver-lets-roam-large-group-scavenger-hunt',
    name: "Let's Roam Large-Group Scavenger Hunt",
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Scavenger Hunt',
    price: '$$',
    groupSize: '2–500+',
    duration: '1.5–3 hrs',
    setting: 'Indoor / Outdoor',
    vibe: ['Collaborative', 'Competitive', 'Customizable', 'Large group'],
    image: categoryImages.scavengerHunt,
    summary:
      'A scalable Denver scavenger hunt that divides a large company group into teams for clues, challenges, and a shared finish.',
    bestFor:
      'Company-wide outings, conference groups, sales teams, and organizations that need one activity to work for 100 to 200 people.',
    details:
      'Let’s Roam offers in-person team-building scavenger hunts with a published starting price. Hosting and customization determine the final per-person range.',
    contact: 'https://www.letsroam.com/team-building/pricing',
  },
  {
    id: 'denver-teambonding-large-group-event',
    name: 'TeamBonding Large-Group Event',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings', 'trainings'],
    category: 'Team Building',
    price: '$$$',
    groupSize: '10–1000+',
    duration: '1–4 hrs / Custom',
    setting: 'Indoor / Outdoor / Virtual',
    vibe: ['Facilitated', 'Customizable', 'Collaborative', 'Large group'],
    image: categoryImages.creative,
    summary:
      'A professionally facilitated large-group program selected from team challenges, charity builds, games, and hybrid formats.',
    bestFor:
      'Company meetings, conference breakouts, distributed teams, and organizations seeking a facilitated program for 100 to 200 people.',
    details:
      'TeamBonding supports events from small teams through 1,000+ participants. Published catalog averages vary based on shipping, materials, facilitation, and customization.',
    contact: 'https://www.teambonding.com/cost/',
  },
  {
    id: 'denver-outback-large-group-team-building',
    name: 'Outback Large-Group Team Building',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings', 'trainings'],
    category: 'Team Building',
    price: '$$',
    groupSize: '10–1000',
    duration: '1–4 hrs / Custom',
    setting: 'Indoor / Outdoor / Virtual',
    vibe: ['Facilitated', 'Flexible', 'Collaborative', 'Large group'],
    image: categoryImages.activeGames,
    summary:
      'A broad catalog of self-hosted and facilitated team programs designed to scale from departments to company-wide groups.',
    bestFor:
      'Large departments, sales meetings, leadership events, conferences, and teams that want multiple formats at different budget levels.',
    details:
      'Outback supports large Denver groups and publishes a very broad price span across self-hosted and premium facilitated programs. Choose a specific format before treating the range as a working budget.',
    contact:
      'https://www.outbackteambuilding.com/team-building/denver/',
  },
  {
    id: 'denver-project-helping-conference-kynd-build',
    name: 'Project Helping Conference Kynd Kit Build',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings', 'volunteer'],
    category: 'Purpose-Driven',
    price: '$$',
    groupSize: '100–1000+',
    duration: '60–120 min',
    setting: 'Indoor / Hybrid',
    vibe: ['Purpose-driven', 'Community impact', 'Inclusive', 'Large group'],
    image: categoryImages.creative,
    summary:
      'A high-capacity volunteer build that gives every attendee a hands-on service project while keeping the whole group in one event space.',
    bestFor:
      'Conferences, all-hands meetings, employee volunteer days, and organizations that want a purpose-driven activity for 100 to 200 people.',
    details:
      'Project Helping publishes volume kit prices, distribution options, and Denver hosting fees. The planning range combines those components for a 100+ person event.',
    contact: 'https://projecthelping.org/kynd-kit-price-list/',
  },
  {
    id: 'denver-colorado-rapids-group-outing',
    name: 'Colorado Rapids Group Outing',
    active: true,
    city: 'Denver',
    state: 'CO',
    primaryCategories: ['outings'],
    category: 'Entertainment',
    price: '$$',
    groupSize: '10+',
    duration: '3–5 hrs',
    setting: 'Outdoor',
    vibe: ['Social', 'Sports', 'Celebration', 'Large group'],
    image: categoryImages.outdoorEvent,
    summary:
      'A professional-soccer group outing with reserved seats and group experiences that can scale well beyond 100 attendees.',
    bestFor:
      'Employee appreciation, client entertainment, summer outings, sports fans, and company groups of 100 to 200 or more.',
    details:
      'The Rapids offer group seating for 10+ guests, with premium group areas and pregame options for larger organizations. No current public group price is posted, so the budget uses a clearly labeled entertainment benchmark.',
    contact: 'https://www.coloradorapids.com/tickets/groups',
  },
  {
  id: 'wyoming-tyson-group-adaptive-selling',
  name: 'Tyson Group Adaptive Selling Training',
  city: 'Casper',
  state: 'WY',
  primaryCategories: ['trainings'],
  category: 'Sales Training',
  price: '$$$',
  groupSize: '5–100+',
  duration: 'Custom / Multi-session',
  setting: 'Indoor / Virtual',
  vibe: [
    'Sales',
    'Communication',
    'Professional Development',
    'Leadership',
  ],
  image:
    'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80',
  summary:
    'Interactive sales training that helps Wyoming teams improve buyer conversations, consultative selling, objection handling, and closing skills.',
  bestFor:
    'Sales teams, business-development employees, account managers, customer-facing teams, new sales representatives, and experienced sellers who need a more consistent sales process.',
  details:
    'Tyson Group’s Adaptive Selling program teaches a buyer-centered sales process covering connection, evaluation, diagnosis, solution presentation, dialogue, and closing. Training can be delivered virtually or brought onsite to a Wyoming organization and customized around its industry, sales challenges, and customer journey.',
  contact:
    'https://www.tysongroup.com/sales-training/adaptive-selling/',
},
].filter((experience) => experience.active !== false);

export const cities = ['All Cities', 'Casper', 'Denver'];

